import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
  styled,
  lighten,
} from "@material-ui/core/styles";
import moment from 'moment';
import Moment from "react-moment";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import "react-toastify/dist/ReactToastify.css";
import grey from "@material-ui/core/colors/grey";
import axios from "axios";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Filters from "./Filters";
import { LinearProgressBar } from "../../shared";
import { Checkbox } from "@material-ui/core";
import { BreadcrumbPage } from "../../shared";
import { getCookie } from "../../services/Cookies";
import { getRequest, postRequest } from "../../services/ApiServices";
import ReportFormat from "./ReportFormat";
import ReportStatus from "./ReportStatus";
import SampleStatus from "./SampleStatus";
import { ThemeProvider } from "@mui/styles";
import { SampleStatusData, ReportStatusColor, TotalSampleStatusData, TotalReportStatusData, SampleStatusColor } from "./SampleStatusInstantiation";
import { reportObj, reportObjlube, reportFualObjSample, reportLubeObjSample, reportTotObjSample, sampleObj, sampleFualObjSample, sampleLubeObjSample, sampleTotObjSample } from "./ReportObj"
import { LOADING } from '../../action';
import { ToastError } from "../../services/ToastMsg";
import { useDispatch } from 'react-redux';
import RowSampleFual from "./RowSampleFual";
import RowReportLube from "./RowReportLube";
import RowReportTot from "./RowReportTot";
import RowReportFual from "./RowReportFual";
import RowSampleLube from "./RowSampleLube";
import RowSampleTot from "./RowSampleTot";
import FiltersReportFuel from "./FiltersReportFuel";
import FiltersReportLube from "./FiltersReportLube";
import FiltersReportTot from "./FiltersReportTot";
import FiltersSampleFule from "./FiltersSampleFule";
import FiltersSampleLube from "./FiltersSampleLube";
import FiltersSampleTot from "./FiltersSampleTot";
import { getCurrentDate, getCurrentDateOfBelow, getDefaultFuelDate, getDefaultLubeDate, getDefaultTotDate } from "../../services/DateServices";
import { getDefaultTabName } from "../../services/FunctionServices";
import { sampleFilterFual } from "./ReportObj"
import { sampleFilterLube } from "./ReportObj"
import { sampleFilterTOT } from "./ReportObj";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import ClearIcon from '@mui/icons-material/Clear';
import Help from "@material-ui/icons/Help";
import ctrl from '../Helpsection_images/ctrl.jpg';
import clear from '../Helpsection_images/clear.jpg';
import cancel from '../Helpsection_images/cancel.jpg';
import applyfilter from '../Helpsection_images/applyfilter.jpg';
import reset from '../Helpsection_images/reset.jpg';
import searchicon from '../Helpsection_images/searchicon.jpg';
import printicon from '../Helpsection_images/printicon.jpg';
import downloadicon from '../Helpsection_images/downloadicon.jpg';
import viewcolumnicon from '../Helpsection_images/viewcolumnicon.jpg';
import filtericon from '../Helpsection_images/filtericon.jpg';
import sampleprogressbar from '../Helpsection_images/sampleprogressbar.jpg';
import sample_fuel_progressbar from '../Helpsection_images/sample_fuel_progressbar.jpg';
import sample_lube_progressbar from '../Helpsection_images/sample_lube_progressbar.jpg';
import pdficon from '../Helpsection_images/pdficon.jpg';
import downloadpdf from '../Helpsection_images/downloadpdf.jpg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import MUIDataTable from "mui-datatables";
import { TableFilterList } from "mui-datatables";
import Chip from '@material-ui/core/Chip';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import {
  MuiThemeProvider,
  createMuiTheme,
  Tooltip,
} from "@material-ui/core";
import CheckBoxIcon from '@mui/icons-material/CheckBox';



const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#000",
    color: "#fff",
  },
  body: {},
}))(TableCell);


const useStyles = makeStyles((theme) => ({

  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"

    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",

    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 17
    }
  },


  roundBox: {
    borderRadius: "50%",
    border: "6px solid #000",
    height: "130px",
    width: "130px",
    textAlign: "center",
  },
  boxShadow_0: {
    boxShadow: "0 0 0 #fff !important",
  },
  btnStyle3: {
    color: "#ff4717",
    boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
    marginLeft: "15px",
    padding: "8px 8px",
    marginLeft: "18px",
    cursor: "pointer",
  },
}));

export default function Reports(props) {
  debugger
  const BreadcrumbList = [{ name: "Dashboard", url: "/dashboard" },
  { name: "Sample Status", url: "" }];
  const classes = useStyles();
  const data = [];
  const [reportData, setReportData] = useState([]);
  const [selectedreportDataFuel, setSelectedReportDataFuel] = useState([]);
  const [selectedreportDataTot, setSelectedReportDataTot] = useState([]);
  const [reportDatalube, setReportDatalube] = useState([]);
  const [selectedreportDatalube, setSelectedReportDatalube] = useState([]);
  const [selectedreportDatalubegrp, setSelectedReportDatalubegrp] = useState([]);
  const [reportDatafuel, setReportDatafuel] = useState([]);
  const [reportDataTot, setReportDataTot] = useState([]);
  // const [formObj, setFormObj] = useState({...sampleFilterFual,...sampleFilterLube,...sampleFilterTOT});
  const [reportTableData, setReportTableData] = useState();
  const [filterStatus, setFilterStatus] = useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const [filterChip, setFilterChip] = useState();
  const [openformFuel, setOpenformFuel] = React.useState(false);
  const [openformLube, setOpenformLube] = React.useState(false);
  const [openformTot, setOpenformTot] = React.useState(false)
  const [isEmpty, setEmpty] = useState(false);
  const [reportDetailsList, setReportDetailsList]

    = useState({
      fuelAnalysisSampleStatus: [], lubeAnalysisSampleStatus: [], totAnalysisSampleStatus: [],
      fuelAnalysisReportStatus: [], lubeAnalysisReportStatus: [], totAnalysisReportStatus: []
    });
  const [clearBarSelection, setClearBarSelection] = useState(true);
  const [globalFilterObj, setGlobalFilterObj] = useState({});
  const [ClearProgressBar, setClearProgressBar] = useState()
  const [DataProgressBar, setDataProgressBar] = useState()
  const [reportDetailsListTotal, setReportDetailsListTotal]
    = useState([]);
  const [reportFormatActive, setReportFormatActive]
    = useState({});
  const [sampleDetailsListTotal, setSampleDetailsListTotal]
    = useState([]);
  const [sampleFormatActive, setSampleFormatActive]
    = useState({});
  const [userSearchedResultIndexes, setUserSearchedResultIndexes] = useState([]);
  const dispatch = useDispatch();
  const [reportType, setReportType] = useState(props.location.type ? props.location.type : "SampleStatus");
  const [reporSubType, setReporSubType] = useState(props.location.subType? props.location.subType: getDefaultTabName()[0]);

  const [moments, setmoment] = useState(0);
  const [selectedRowCount, setSelectedRowCount] = useState(0);
  const [tabName, settabName] = React.useState();
  const [date, setDate] = React.useState([]);
  const [grouping, setGrouping] = React.useState(getCookie('grouping'));
  // // [formObj, setFormObj] = useState(reporSubType == "Lube" ? sampleFilterLube : reporSubType == "Fuel" ? sampleFilterFual :
  //   reporSubType == "Tot" ? sampleFilterTOT : {});
  const getMuiTheme = () => createTheme({

    overrides: {
      MUIDataTableHeadCell: {
        root: {
          textTransform: "none"
        }
      }
    },
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          filterPaper: {
            width: "450px",
          }
        }
      }
    },
  })
  const handleClickOpen = () => {
    console.log(reporSubType, reportType);
    if (reporSubType == "Fuel" && reportType == "SampleStatus") {
      setOpenformFuel(true);

    }
    if (reporSubType == "Lube" && reportType == "SampleStatus") {
      setOpenformLube(true);
    }
    if (reporSubType == "Tot" && reportType == "SampleStatus") {
      setOpenformTot(true);
    }
  };
  const handleClickClose = () => {
    setOpenformFuel(false);
  };

  const handleClickCloseLube = () => {
    setOpenformLube(false);
  };

  const handleClickCloseTot = () => {
    setOpenformTot(false);
  };
  const IntialPageLoading = () => {

    if (reporSubType == "Fuel") {
      IntialFuelLoadEffect()
    }
    else if (reporSubType == "Lube") {
      IntialLubeLoadEffect()
    }
    else {
      IntialTotLoadEffect()
    }
  }
  useEffect(() => {
    IntialPageLoading()
    loadAPIData();
    //LubeDateField()
  }, []);
  const LubeDateField = () => {
    let dateValue = getDefaultLubeDate();
    setDate(dateValue);
  }
  const DateFieldChange = () => {

    const dateValue = getDefaultLubeDate();
    setDate(dateValue);
  }

  // React.useEffect(()=>{
  //   
  //   const dateValue=getDefaultLubeDate();
  //   setDate(dateValue);
  // },[])
  const IntialFuelLoadEffect = () => {
    debugger
    let getCookieval = "";
    if (localStorage.getItem('FilterSetting') !== "" && localStorage.getItem('FilterSetting') !== undefined && localStorage.getItem('FilterSetting') !== null && localStorage.getItem('FilterSetting') !== "null") {
      getCookieval = localStorage.getItem('FilterSetting')
    }
    else{
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      let JSONFormat = Obj
      JSONFormat = {
        ...Obj
      }
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      let SampleStartDate = (Obj.Fqtsamplestartdate && Obj.Fqtsamplestartdate[0] ? Obj.Fqtsamplestartdate[0] : Obj.Fqtsamplestartdate);
      let SampleEndDate = (Obj.Fqtsampleenddate && Obj.Fqtsampleenddate[0] ? Obj.Fqtsampleenddate[0] : Obj.Fqtsampleenddate)
      if (SampleStartDate && SampleEndDate && SampleStartDate != null && SampleEndDate != null) {
        JSONFormat.sampleDate = {
          startDate: moment(SampleStartDate).format('YYYY/MM/DD'),
          endDate: moment(SampleEndDate).format('YYYY/MM/DD')
        };
      }
      else {
        let dt = getDefaultFuelDate();
        JSONFormat.sampleDate = {
          startDate: moment(dt.startDate).format('YYYY/MM/DD'),
          endDate: moment(dt.endDate).format('YYYY/MM/DD')
        };
      }
      debugger
      filterSampleFuel(JSONFormat);

    } else {
      let JSONFormat = {};
      let dt = getDefaultFuelDate();
      JSONFormat.sampleDate = {
        startDate: moment(dt.startDate).format('YYYY/MM/DD'),
        endDate: moment(dt.endDate).format('YYYY/MM/DD')
      };
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      debugger
      filterSampleFuel(JSONFormat);
    }
  }
  const IntialLubeLoadEffect = () => {
    debugger
    let getCookieval = "";
    if (localStorage.getItem('FilterSetting') !== "" && localStorage.getItem('FilterSetting') !== undefined && localStorage.getItem('FilterSetting') !== null && localStorage.getItem('FilterSetting') !== "null") {
      getCookieval = localStorage.getItem('FilterSetting')
    }
    else {
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      let JSONFormat = Obj
      JSONFormat = {
        ...Obj
      }
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      let SampleStartDate = (Obj.lubesamplestartdate && Obj.lubesamplestartdate[0] ? Obj.lubesamplestartdate[0] : Obj.lubesamplestartdate);
      let SampleEndDate = (Obj.lubesampleenddate && Obj.lubesampleenddate[0] ? Obj.lubesampleenddate[0] : Obj.lubesampleenddate)
      if (SampleStartDate && SampleEndDate && SampleStartDate != null && SampleEndDate != null) {
        JSONFormat.sampleDate = {
          startDate: moment(SampleStartDate).format('YYYY/MM/DD'),
          endDate: moment(SampleEndDate).format('YYYY/MM/DD')
        };
      }
      else {
        let dt = getDefaultLubeDate();
        JSONFormat.sampleDate = {
          startDate: moment(dt.startDate).format('YYYY/MM/DD'),
          endDate: moment(dt.endDate).format('YYYY/MM/DD')
        };
      }
      filterSampleLube(JSONFormat);

    } else {
      let JSONFormat = {};
      let dt = getDefaultLubeDate();
      JSONFormat.sampleDate = {
        startDate: moment(dt.startDate).format('YYYY/MM/DD'),
        endDate: moment(dt.endDate).format('YYYY/MM/DD')
      };
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      filterSampleLube(JSONFormat);
    }

    /*  let dateValue=getDefaultLubeDate();
     setDate(dateValue); */
  }
  const IntialTotLoadEffect = () => {

    let getCookieval = "";
    if (localStorage.getItem('TOTFilterSetting') !== "" && localStorage.getItem('TOTFilterSetting') !== undefined && localStorage.getItem('TOTFilterSetting') !== null && localStorage.getItem('TOTFilterSetting') !== "null") {
      getCookieval = localStorage.getItem('TOTFilterSetting')
    }
    else {
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      let JSONFormat = Obj
      JSONFormat = {
        ...Obj
      }
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      let SampleStartDate = (Obj.Totsamplestartdate && Obj.Totsamplestartdate[0] ? Obj.Totsamplestartdate[0] : Obj.Totsamplestartdate);
      let SampleEndDate = (Obj.Totsampleenddate && Obj.Totsampleenddate[0] ? Obj.Totsampleenddate[0] : Obj.Totsampleenddate)
      if (SampleStartDate && SampleEndDate && SampleStartDate != null && SampleEndDate != null) {
        JSONFormat.sampleDate = {
          startDate: moment(SampleStartDate).format('YYYY/MM/DD'),
          endDate: moment(SampleEndDate).format('YYYY/MM/DD')
        };
      } else {
        let dt = getDefaultTotDate();
        JSONFormat.sampleDate = {
          startDate: moment(dt.startDate).format('YYYY/MM/DD'),
          endDate: moment(dt.endDate).format('YYYY/MM/DD')
        };
      }
      filterSampleTot(JSONFormat);

    } else {
      let JSONFormat = {};
      let dt = getDefaultTotDate();
      JSONFormat.sampleDate = {
        startDate: moment(dt.startDate).format('YYYY/MM/DD'),
        endDate: moment(dt.endDate).format('YYYY/MM/DD')
      };
      if (getCookie('historicvessels') === 'true') {
        JSONFormat.HistoricVessel = true;
      } else {
        JSONFormat.HistoricVessel = false;
      }
      filterSampleTot(JSONFormat);
    }
  }
  const getcurrentDateByReportSubType = (type) => {
    ////
    if (type == "Fuel") {
      return getCurrentDateOfBelow(90)
    } else if (type == "Lube") {
      return getCurrentDateOfBelow(180)
    } else if (type == "Tot") {
      return getCurrentDateOfBelow(730)
    }
  }
  const loadAPIData = async () => {
    debugger
    //await getReports(getCookie("clientId"));
    if (reporSubType == "Fuel" && reportType == "SampleStatus") {
      //filterSampleFuel(formObj)
      //await getReportFualDrillDown("Report/FuelAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Fuel");
    }
    if (reporSubType == "Fuel" && reportType == "ReportStatus") {
      await getReportFualDrillDown("Report/FuelAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Fuel");
    }
    if (reporSubType == "Lube" && reportType == "SampleStatus") {
      //await getReportFualDrillDown("Report/LubeAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Lube");
    }
    if (reporSubType == "Lube" && reportType == "ReportStatus") {
      await getReportFualDrillDown("Report/LubeAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Lube");
    }
    if (reporSubType == "Tot" && reportType == "SampleStatus") {
      //await getReportFualDrillDown("Report/ToTAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Tot");
    }
    if (reporSubType == "Tot" && reportType == "ReportStatus") {
      await getReportFualDrillDown("Report/ToTAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Tot");
    }
  }

  /** Filters S*/
  const filterReportFual = async (formObj) => {
    setReportData([]);
    let filterObj = {};
    if (formObj.contract) { filterObj = { ...filterObj, contract: formObj.contract } }
    if (formObj.vessel) { filterObj = { ...filterObj, vessel: formObj.vessel } }
    if (formObj.bunkerPort) { filterObj = { ...filterObj, bunkerPort: formObj.bunkerPort } }
    if (formObj.bunkeredFromDate) { filterObj = { ...filterObj, bunkeredFromDate: formObj.bunkeredFromDate } }
    if (formObj.bunkeredToDate) { filterObj = { ...filterObj, bunkeredToDate: formObj.bunkeredToDate } }
    if (formObj.sampledFromDate) { filterObj = { ...filterObj, sampledFromDate: formObj.sampledFromDate } }
    if (formObj.sampledToDate) { filterObj = { ...filterObj, sampledToDate: formObj.sampledToDate } }
    if (formObj.sampleNumber) { filterObj = { ...filterObj, sampleNumber: formObj.sampleNumber } }
    if (formObj.reportType) { filterObj = { ...filterObj, reportType: formObj.reportType } }
    if (formObj.statusType) { filterObj = { ...filterObj, statusType: formObj.statusType } }
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/FuelAnalysis/ReportStatus/DrillDown/Filter`;
    await postRequest(url, filterObj)
      .then((res) => {
        // if(reporSubType == "Fuel" && reportType == "ReportStatus" ){
        if (res.data.fuelAnalysisReportStatus_data) {
          setReportData(getReportFualFormat(res.data.fuelAnalysisReportStatus_data));
        }
        if (res.data.fuelAnalysisReportStatus_chart) {
          setReportFormatActive(getReportTotalData(res.data.fuelAnalysisReportStatus_chart));

          const objData = { fuelAnalysisReportStatus: getReportData(res.data.fuelAnalysisReportStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        // }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { fuelAnalysisReportStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  const filterReportLube = async (formObj) => {
    setReportData([]);
    let filterObj = {};
    if (formObj.vessel) { filterObj = { ...filterObj, vessel: formObj.vessel } }
    if (formObj.equipmentName) { filterObj = { ...filterObj, equipmentName: formObj.equipmentName } }
    if (formObj.equipmentMake) { filterObj = { ...filterObj, equipmentMake: formObj.equipmentMake } }
    if (formObj.equipmentModel) { filterObj = { ...filterObj, equipmentModel: formObj.equipmentModel } }

    if (formObj.reportedFromDate) { filterObj = { ...filterObj, reportedFromDate: formObj.reportedFromDate } }
    if (formObj.reportedToDate) { filterObj = { ...filterObj, reportedToDate: formObj.reportedToDate } }
    if (formObj.sampledFromDate) { filterObj = { ...filterObj, sampledFromDate: formObj.sampledFromDate } }
    if (formObj.sampledToDate) { filterObj = { ...filterObj, sampledToDate: formObj.sampledToDate } }
    if (formObj.reportType) { filterObj = { ...filterObj, reportType: formObj.reportType } }
    if (formObj.statusType) { filterObj = { ...filterObj, statusType: formObj.statusType } }
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/LubeAnalysis/ReportStatus/DrillDown/Filter`;
    await postRequest(url, filterObj)
      .then((res) => {
        // if(reporSubType == "Fuel" && reportType == "ReportStatus" ){
        if (res.data.lubeAnalysisReportStatus_data) {
          setReportData(getReportLubeFormat(res.data.lubeAnalysisReportStatus_data));
        }
        if (res.data.lubeAnalysisReportStatus_chart) {
          setReportFormatActive(getReportTotalData(res.data.lubeAnalysisReportStatus_chart));

          const objData = { lubeAnalysisReportStatus: getReportData(res.data.lubeAnalysisReportStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        // }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { lubeAnalysisReportStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  const filterReportTot = async (formObj) => {

    setReportData([]);
    let filterObj = {};
    if (formObj.transformer) { filterObj = { ...filterObj, transformer: formObj.transformer } }
    if (formObj.location) { filterObj = { ...filterObj, location: formObj.location } }
    if (formObj.contract) { filterObj = { ...filterObj, contract: formObj.contract } }
    if (formObj.rating) { filterObj = { ...filterObj, rating: formObj.rating } }
    if (formObj.sampleNumber) { filterObj = { ...filterObj, sampleNumber: formObj.sampleNumber } }

    if (formObj.voltage) { filterObj = { ...filterObj, voltage: formObj.voltage } }
    if (formObj.reportedFromDate) { filterObj = { ...filterObj, reportedFromDate: formObj.reportedFromDate } }
    if (formObj.reportedToDate) { filterObj = { ...filterObj, reportedToDate: formObj.reportedToDate } }
    if (formObj.sampledFromDate) { filterObj = { ...filterObj, sampledFromDate: formObj.sampledFromDate } }
    if (formObj.sampledToDate) { filterObj = { ...filterObj, sampledToDate: formObj.sampledToDate } }
    if (formObj.statusType) { filterObj = { ...filterObj, statusType: formObj.statusType } }
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/ToTAnalysis/ReportStatus/DrillDown/Filter`;
    await postRequest(url, filterObj)
      .then((res) => {
        // if(reporSubType == "Fuel" && reportType == "ReportStatus" ){
        if (res.data.toTAnalysisReportStatus_data) {
          setReportData(getReportTotFormat(res.data.toTAnalysisReportStatus_data));
        }
        if (res.data.toTAnalysisReportStatus_chart) {
          setReportFormatActive(getReportTotalData(res.data.toTAnalysisReportStatus_chart));
          const objData = { totAnalysisReportStatus: getReportData(res.data.toTAnalysisReportStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        // }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { totAnalysisReportStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  const filterSampleFuel = async (formObj) => {
    debugger
    setFilterChip(true);
    if (formObj.Fqtsamplestatus && formObj.Fqtsamplestatus != "") {
      setClearBarSelection(false);
    }
    else {
      setClearBarSelection(true);
    }
    //setFuelReportData([]);
    setReportData([]);
    setGlobalFilterObj(formObj);
    let filterObj = {};
    if (formObj.HistoricVessel == true) {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
    } else {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
    }
    if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
    if (formObj.shipNameImokey && formObj.shipNameImokey.length > 0) { filterObj = { ...filterObj, shipNameImokey: formObj.shipNameImokey } }
    if (formObj.Fqtbunkerport && formObj.Fqtbunkerport.length > 0) { filterObj = { ...filterObj, Fqtbunkerport: formObj.Fqtbunkerport } }
    if (formObj.Fqtbargename && formObj.Fqtbargename.length > 0) { filterObj = { ...filterObj, Fqtbargename: formObj.Fqtbargename } }
    if (formObj.Fqtsamplenumber && formObj.Fqtsamplenumber.length > 0) { filterObj = { ...filterObj, Fqtsamplenumber: formObj.Fqtsamplenumber } }
    if (formObj.Fqtlab && formObj.Fqtlab.length > 0) { filterObj = { ...filterObj, Fqtlab: formObj.Fqtlab } }
    if (formObj.servicetype && formObj.servicetype.length > 0) { filterObj = { ...filterObj, servicetype: formObj.servicetype } }
    if (formObj.FqtSupplier && formObj.FqtSupplier.length > 0) { filterObj = { ...filterObj, FqtSupplier: formObj.FqtSupplier } }
    if (formObj.Fqtsamplestatus && formObj.Fqtsamplestatus.length > 0) { filterObj = { ...filterObj, Fqtsamplestatus: formObj.Fqtsamplestatus } }
    if (formObj.Fqtfuelgrade && formObj.Fqtfuelgrade.length > 0) { filterObj = { ...filterObj, Fqtfuelgrade: formObj.Fqtfuelgrade } }
    if (formObj.FqtOffSpec && formObj.FqtOffSpec.length > 0) { filterObj = { ...filterObj, FqtOffSpec: formObj.FqtOffSpec } }
    if (formObj.sampleDate) { filterObj = { ...filterObj, sampleDate: formObj.sampleDate } }
    //setFormObj(formObj)
    let Data = {};
    if (formObj.sampleDate) {
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    } else {
      let JSONFormat = filterObj
      let sampleStartDate = (formObj.Fqtsamplestartdate[0].startDate ? formObj.Fqtsamplestartdate[0].startDate : formObj.Fqtsamplestartdate[0]);
      let sampleEndDate = (formObj.Fqtsampleenddate[0].endDate ? formObj.Fqtsampleenddate[0].endDate : formObj.Fqtsampleenddate[0])
      JSONFormat = {
        ...filterObj,
        sampleDate: {
          startDate: moment(sampleStartDate).format('YYYY/MM/DD'),
          endDate: moment(sampleEndDate).format('YYYY/MM/DD')
        }
      }
      const myJSONData = JSON.stringify(JSONFormat);
      Data = {
        Data: myJSONData,
      }
    }

    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/FuelAnalysis/SampleStatus/DrillDown/Filter`;
    await postRequest(url, Data)
      .then((res) => {
        debugger
        res.data.fuelAnalysisSampleStatus_data.forEach((d) => {
          if (d.samplingDt) {
            d.samplingDt = moment(d.samplingDt).format('DD/MM/YYYY');
          }
          if (d.reportDt) {
            d.reportDt = moment(d.reportDt).format('DD/MM/YYYY');
          }
          if (d.arrivedOnDt) {
            d.arrivedOnDt = moment(d.arrivedOnDt).format('DD/MM/YYYY');
          }
          if (d.testedDt) {
            d.testedDt = moment(d.testedDt).format('DD/MM/YYYY');
          }
        })
        // if(reporSubType == "Fuel" && reportType == "ReportStatus" ){
        if (res.data.fuelAnalysisSampleStatus_data) {

          setReportData(getSampleFualFormat(res.data.fuelAnalysisSampleStatus_data))
          console.log(res.data.fuelAnalysisSampleStatus_data)


        }

        if (res.data.fuelAnalysisSampleStatus_chart) {
          setSampleFormatActive(getSampleTotalData(res.data.fuelAnalysisSampleStatus_chart));

          const objData = { fuelAnalysisSampleStatus: getSampleData(res.data.fuelAnalysisSampleStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        // }

        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { fuelAnalysisSampleStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  const filterSampleLube = async (formObj) => {
    debugger
    setFilterChip(true);
    if (formObj.lubesamplestatus && formObj.lubesamplestatus != "") {
      setClearBarSelection(false);
    }
    else {
      setClearBarSelection(true);
    }
    setReportData([]);
    setGlobalFilterObj(formObj);
    let filterObj = {};
    if (formObj.HistoricVessel == true) {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
    } else {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
    }
    if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
    if (formObj.shipNameImokey && formObj.shipNameImokey.length > 0) { filterObj = { ...filterObj, shipNameImokey: formObj.shipNameImokey } }
    if (formObj.lobrand && formObj.lobrand.length > 0) { filterObj = { ...filterObj, lobrand: formObj.lobrand } }
    if (formObj.lograde && formObj.lograde.length > 0) { filterObj = { ...filterObj, lograde: formObj.lograde } }
    if (formObj.lubeequipname && formObj.lubeequipname.length > 0) { filterObj = { ...filterObj, lubeequipname: formObj.lubeequipname } }
    if (formObj.lubelab && formObj.lubelab.length > 0) { filterObj = { ...filterObj, lubelab: formObj.lubelab } }
    if (formObj.servicetype && formObj.servicetype.length > 0) { filterObj = { ...filterObj, servicetype: formObj.servicetype } }
    if (formObj.lubeequipmodel && formObj.lubeequipmodel.length > 0) { filterObj = { ...filterObj, lubeequipmodel: formObj.lubeequipmodel } }
    if (formObj.lubeequipmake && formObj.lubeequipmake.length > 0) { filterObj = { ...filterObj, lubeequipmake: formObj.lubeequipmake } }
    if (formObj.lubesamplestatus && formObj.lubesamplestatus.length > 0) { filterObj = { ...filterObj, lubesamplestatus: formObj.lubesamplestatus } }
    if (formObj.sampleDate) { filterObj = { ...filterObj, sampleDate: formObj.sampleDate } }
    let Data = {};
    if (formObj.sampleDate) {
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    } else {
      let JSONFormat = filterObj
      let sampleStartDate = (formObj.lubesamplestartdate[0].startDate ? formObj.lubesamplestartdate[0].startDate : formObj.lubesamplestartdate[0]);
      let sampleEndDate = (formObj.lubesampleenddate[0].endDate ? formObj.lubesampleenddate[0].endDate : formObj.lubesampleenddate[0])
      JSONFormat = {
        ...filterObj,
        sampleDate: {
          startDate: moment(sampleStartDate).format('YYYY/MM/DD'),
          endDate: moment(sampleEndDate).format('YYYY/MM/DD')
        }

      }
      const myJSONData = JSON.stringify(JSONFormat);
      Data = {
        Data: myJSONData,
      }
    }

    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/LubeAnalysis/SampleStatus/DrillDown/Filter`;
    await postRequest(url, Data)
      .then((res) => {
        res.data.lubeAnalysisSampleStatus_data.forEach((d) => {
          if (d.samplingDt) {
            d.samplingDt = moment(d.samplingDt).format('DD/MM/YYYY');
          }
          if (d.reportDt) {
            d.reportDt = moment(d.reportDt).format('DD/MM/YYYY');
          }
          if (d.arrivedOnDt) {
            d.arrivedOnDt = moment(d.arrivedOnDt).format('DD/MM/YYYY');
          }
          if (d.testedDt) {
            d.testedDt = moment(d.testedDt).format('DD/MM/YYYY');
          }
        })

        if (res.data.lubeAnalysisSampleStatus_data) {
          setReportData(getSampleLubeFormat(res.data.lubeAnalysisSampleStatus_data));
          setReportDatalube(getSampleLubeFormatlube(res.data.lubeAnalysisSampleStatus_data));

        }
        if (res.data.lubeAnalysisSampleStatus_chart) {
          setSampleFormatActive(getSampleTotalData(res.data.lubeAnalysisSampleStatus_chart));

          const objData = { lubeAnalysisSampleStatus: getSampleData(res.data.lubeAnalysisSampleStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        // }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { lubeAnalysisSampleStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  const filterSampleTot = async (formObj) => {
    debugger
    setFilterChip(true);
    if (formObj.Totsamplestatus && formObj.Totsamplestatus != "") {
      setClearBarSelection(false);
    }
    else {
      setClearBarSelection(true);
    }
    setReportData([]);
    setGlobalFilterObj(formObj);
    let filterObj = {};
    if (formObj.HistoricVessel == true) {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
    } else {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
    }
    if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
    if (formObj.Totserialnumber && formObj.Totserialnumber.length > 0) { filterObj = { ...filterObj, Totserialnumber: formObj.Totserialnumber } }
    if (formObj.Totclientcontract && formObj.Totclientcontract.length > 0) { filterObj = { ...filterObj, Totclientcontract: formObj.Totclientcontract } }
    if (formObj.Totmanufacture && formObj.Totmanufacture.length > 0) { filterObj = { ...filterObj, Totmanufacture: formObj.Totmanufacture } }
    if (formObj.Totsamplestatus && formObj.Totsamplestatus.length > 0) { filterObj = { ...filterObj, Totsamplestatus: formObj.Totsamplestatus } }
    if (formObj.Totsamplenumber && formObj.Totsamplenumber.length > 0) { filterObj = { ...filterObj, Totsamplenumber: formObj.Totsamplenumber } }
    if (formObj.Totlocation && formObj.Totlocation.length > 0) { filterObj = { ...filterObj, Totlocation: formObj.Totlocation } }
    if (formObj.Totvoltage && formObj.Totvoltage.length > 0) { filterObj = { ...filterObj, Totvoltage: formObj.Totvoltage } }
    if (formObj.TotRating && formObj.TotRating.length > 0) { filterObj = { ...filterObj, TotRating: formObj.TotRating } }
    if (formObj.TotSubCustomerName && formObj.TotSubCustomerName.length > 0) { filterObj = { ...filterObj, TotSubCustomerName: formObj.TotSubCustomerName } }
    if (formObj.TotUnitDescription && formObj.TotUnitDescription.length > 0) { filterObj = { ...filterObj, TotUnitDescription: formObj.TotUnitDescription } }
    if (formObj.Totlab && formObj.Totlab.length > 0) { filterObj = { ...filterObj, Totlab: formObj.Totlab } }
    if (formObj.sampleDate) { filterObj = { ...filterObj, sampleDate: formObj.sampleDate } }
    let Data = {};
    if (formObj.sampleDate) {
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    } else {
      let JSONFormat = filterObj
      let sampleStartDate = (formObj.Totsamplestartdate[0].startDate ? formObj.Totsamplestartdate[0].startDate : formObj.Totsamplestartdate[0]);
      let sampleEndDate = (formObj.Totsampleenddate[0].endDate ? formObj.Totsampleenddate[0].endDate : formObj.Totsampleenddate[0])
      JSONFormat = {
        ...filterObj,
        sampleDate: {
          startDate: moment(sampleStartDate).format('YYYY/MM/DD'),
          endDate: moment(sampleEndDate).format('YYYY/MM/DD')
        }
      }
      const myJSONData = JSON.stringify(JSONFormat);
      Data = {
        Data: myJSONData,
      }
    }
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/ToTAnalysis/SampleStatus/DrillDown/Filter`;
    await postRequest(url, Data)
      .then((res) => {
        res.data.toTAnalysisSampleStatus_data.forEach((d) => {
          if (d.samplingDt) {
            d.samplingDt = moment(d.samplingDt).format('DD/MM/YYYY');
          }
          if (d.reportDt) {
            d.reportDt = moment(d.reportDt).format('DD/MM/YYYY');
          }
          if (d.arrivedOnDt) {
            d.arrivedOnDt = moment(d.arrivedOnDt).format('DD/MM/YYYY');
          }
          if (d.testedDt) {
            d.testedDt = moment(d.testedDt).format('DD/MM/YYYY');
          }
        })

        // if(reporSubType == "Fuel" && reportType == "ReportStatus" ){
        if (res.data.toTAnalysisSampleStatus_data) {
          setReportData(getSampleTotFormat(res.data.toTAnalysisSampleStatus_data));

          // setReportDataTot(getSampleTotFormatTot(res.data.toTAnalysisSampleStatus_data));
        }
        if (res.data.toTAnalysisSampleStatus_chart) {
          setSampleFormatActive(getSampleTotalData(res.data.toTAnalysisSampleStatus_chart));

          const objData = { totAnalysisSampleStatus: getSampleData(res.data.toTAnalysisSampleStatus_chart) };
          setReportDetailsList({ ...reportDetailsList, ...objData });
        }
        setFilterStatus(true);
        // }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        setReportData([]);
        setReportFormatActive([]);
        const objData = { totAnalysisSampleStatus: [] };
        setReportDetailsList({ ...reportDetailsList, ...objData });
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  const FormatClearFilter = (Obj) => {
    //
    if (reporSubType == "Fuel") {
      let FuelProgressBar = ""
      let FuelProgresstate = ""
      if (Obj.Fqtsamplestatus.length) {
        FuelProgressBar = Obj.Fqtsamplestatus[0].name ? true : false
        FuelProgresstate = Obj.Fqtsamplestatus[0].name
      }
      setClearProgressBar(FuelProgressBar)
      setDataProgressBar(FuelProgresstate)
    }
    else if (reporSubType == "Lube") {
      let LubeProgressBar = ""
      let LubeProgresstate = ""
      if (Obj.lubesamplestatus.length) {
        LubeProgressBar = Obj.lubesamplestatus[0].name ? true : false
        LubeProgresstate = Obj.lubesamplestatus[0].name
      }
      setClearProgressBar(LubeProgressBar)
      setDataProgressBar(LubeProgresstate)
    }
    else if (reporSubType == "Tot") {
      let TotProgressBar = ""
      let TotProgresstate = ""
      if (Obj.Totsamplestatus.length) {
        TotProgressBar = Obj.Totsamplestatus[0].name ? true : false
        TotProgresstate = Obj.Totsamplestatus[0].name
      }
      setClearProgressBar(TotProgressBar)
      setDataProgressBar(TotProgresstate)
    }
  }
  const Resetclearprogressbar = () => {
    //
    setClearProgressBar(false)
  }
  const clearFilter = () => {
    loadAPIData();
    setEmpty(true);
  }
  /** Filters E*/

  const getReportFualDrillDown = async (urlType, customerKeys, subType) => {
    debugger
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `${urlType}`;

    ////
    const data = {
      "CustomerKeys": customerKeys,
      "FuelStartDate": getcurrentDateByReportSubType(subType),
      "FuelEndDate": getCurrentDate(),
      "LubeStartDate": getcurrentDateByReportSubType(subType),
      "LubeEndDate": getCurrentDate(),
      "TotStartDate": getcurrentDateByReportSubType(subType),
      "TotEndDate": getCurrentDate()
    }
    await postRequest(url, data)
      .then((res) => {

        ////console.log("sample-type", reporSubType,reportType );
        if (subType == "Fuel" && reportType == "ReportStatus") {
          setReportData(getReportFualFormat(res.data));
        }
        if (subType == "Fuel" && reportType == "SampleStatus") {
          setReportData(getSampleFualFormat(res.data));

        }
        if (subType == "Lube" && reportType == "ReportStatus") {
          setReportData(getReportLubeFormat(res.data));
        }
        if (subType == "Lube" && reportType == "SampleStatus") {
          setReportData(getSampleLubeFormat(res.data));
          setReportDatalube(getSampleLubeFormatlube(res.data));
        }
        if (subType == "Tot" && reportType == "ReportStatus") {
          setReportData(getReportTotFormat(res.data));
        }
        if (subType == "Tot" && reportType == "SampleStatus") {
          setReportData(getSampleTotFormat(res.data));
          // setReportDataTot(getSampleTotFormatTot(res.data));
        }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }

  /** DrillDown Grouping S*/

  /** Report DrillDown */
  const getReportFualFormat = (data) => {
    ;
    let contractList = [];
    let vesselList = [];
    let ReportData = [];
    data.map((item) => {
      let indexContract = contractList.indexOf(item.axContractId);
      if (indexContract > -1) {
        let indexVessel = vesselList[indexContract].indexOf(item.currentVesselName);
        if (indexVessel > -1) {
          let objSampleData = {
            ...reportFualObjSample,
            SampleID: item.sampleControlNoCd,
            ProductType: item.pdfDocumentType,
            SupplierName: item.supplierName,
            Parameters: item.testParameter,
            Limits: item.lowerLimit + '-' + item.upperLimit,
            TestResults: item.testNumericValue,
            BunkeredDate: item.bunkeringDt,
            pdfFileName: item.pdfFileName,
            BunkeredPort: item.portName,
            ProductType: item.productType,
            ReportDate: item.reportDt,
            Flag: item.status
          }
          ReportData[indexVessel].SampleList.push(objSampleData);
        } else {
          vesselList[indexContract].push(item.currentVesselName);
          let objSampleData = {
            ...reportFualObjSample,
            SampleID: item.sampleControlNoCd,
            ProductType: item.pdfDocumentType,
            SupplierName: item.supplierName,
            Parameters: item.testParameter,
            Limits: item.lowerLimit + '-' + item.upperLimit,
            TestResults: item.testNumericValue,
            BunkeredDate: item.bunkeringDt,
            pdfFileName: item.pdfFileName,
            BunkeredPort: item.portName,
            ProductType: item.productType,
            ReportDate: item.reportDt,
            Flag: item.status
          }
          let objData = {
            ...reportObj,
            CustomerContract: item.axContractId,
            VesselName: item.currentVesselName,
            Dispatchport: item.portName,
            BunkeredDate: item.bunkeringDt,
            Status: item.status,
            pdfFileName: item.pdfFileName,
            SampleList: [objSampleData]
          }
          ReportData.push(objData);
        }
      } else {
        contractList.push(item.axContractId);
        let arr = [item.currentVesselName];
        vesselList.push(arr);
        let objSampleData = {
          ...reportFualObjSample,
          SampleID: item.sampleControlNoCd,
          ProductType: item.pdfDocumentType,
          SupplierName: item.supplierName,
          Parameters: item.testParameter,
          Limits: item.lowerLimit + '-' + item.upperLimit,
          TestResults: item.testNumericValue,
          BunkeredDate: item.bunkeringDt,
          pdfFileName: item.pdfFileName,
          BunkeredPort: item.portName,
          ProductType: item.productType,
          ReportDate: item.reportDt,
          Flag: item.status
        }
        let objData = {
          ...reportObj,
          CustomerContract: item.axContractId,
          VesselName: item.currentVesselName,
          Dispatchport: item.portName,
          BunkeredDate: item.bunkeringDt,
          Status: item.status,
          pdfFileName: item.pdfFileName,
          SampleList: [objSampleData]
        }
        ReportData.push(objData);
      }

    })
    return ReportData;
  }
  const getReportLubeFormat = (data) => {
    let contractList = [];
    let equipmentList = [];
    let vesselList = [];
    let ReportData = [];
    data.map((item) => {
      let indexContract = contractList.indexOf(item.axContractId);
      if (indexContract > -1) {
        let indexVessel = vesselList[indexContract].indexOf(item.vesselId);
        if (indexVessel > -1) {
          let objSampleData = {
            ...reportLubeObjSample,
            SampleID: item.sampleControlNoCd,
            ReportsDescription: item.pdfFileName,
            ReportType: item.serviceType,
            Make: item.make,
            Model: item.model,
            LOTypeBrand: item.sampleLubeBrand + '' + item.sampleLubeType,
            ReportDate: item.reportDt,
            pdfFileName: item.pdfFileName,
            equipmentDescription: item.equipmentDescription,
            Flag: item.status
          }
          ReportData[indexVessel].SampleList.push(objSampleData);
        } else {
          vesselList[indexContract].push(item.vesselId);
          let objSampleData = {
            ...reportLubeObjSample,
            SampleID: item.sampleControlNoCd,
            ReportsDescription: item.pdfFileName,
            ReportType: item.serviceType,
            Make: item.make,
            Model: item.model,
            LOTypeBrand: item.sampleLubeBrand + '' + item.sampleLubeType,
            ReportDate: item.reportDt,
            pdfFileName: item.pdfFileName,
            equipmentDescription: item.equipmentDescription,
            Flag: item.status
          }
          let objData = {
            ...reportObj,
            CustomerContract: item.axContractId,
            VesselName: item.imoNo,
            Dispatchport: item.portName,
            BunkeredDate: item.reportDt,
            Status: item.status,
            pdfFileName: item.pdfFileName,
            SampleList: [objSampleData]
          }
          ReportData.push(objData);
        }
      } else {
        contractList.push(item.axContractId);
        var arr = [item.vesselId];
        vesselList.push(arr);
        let objSampleData = {
          ...reportLubeObjSample,
          SampleID: item.sampleControlNoCd,
          ReportsDescription: item.pdfFileName,
          ReportType: item.serviceType,
          Make: item.make,
          Model: item.model,
          LOTypeBrand: item.sampleLubeBrand + '' + item.sampleLubeType,
          ReportDate: item.reportDt,
          pdfFileName: item.pdfFileName,
          equipmentDescription: item.equipmentDescription,
          Flag: item.status
        }
        let objData = {
          ...reportObj,
          CustomerContract: item.axContractId,
          VesselName: item.imoNo,
          Dispatchport: item.portName,
          BunkeredDate: item.reportDt,
          Status: item.status,
          pdfFileName: item.pdfFileName,
          SampleList: [objSampleData]
        }
        ReportData.push(objData);
      }

    })
    return ReportData;
  }
  const getReportTotFormat = (data) => {

    let contractList = [];
    let tranformerList = [];
    let ReportData = [];
    data.map((item) => {
      let indexContract = contractList.indexOf(item.axContractId);
      if (indexContract > -1) {
        let indexTranformer = tranformerList[indexContract].indexOf(item.tranformerName);
        if (indexTranformer > -1) {
          let objSampleData = {
            ...reportTotObjSample,
            SampleID: item.sampleControlNoCd,
            ReportsDescription: item.pdfFileName,
            ReportType: item.serviceType,
            ReportDate: item.reportDt,
            pdfFileName: item.pdfFileName,
            Flag: item.status
          }
          ReportData[indexTranformer].SampleList.push(objSampleData);
        } else {
          tranformerList[indexContract].push(item.tranformerName);
          let objSampleData = {
            ...reportTotObjSample,
            SampleID: item.sampleControlNoCd,
            ReportsDescription: item.pdfFileName,
            ReportType: item.serviceType,
            ReportDate: item.reportDt,
            pdfFileName: item.pdfFileName,
            Flag: item.status
          }
          let objData = {
            ...reportObj,
            CustomerContract: item.axContractId,
            VesselName: item.tranformerName,
            Dispatchport: item.portName,
            BunkeredDate: item.reportDt,
            Status: item.status,
            pdfFileName: item.pdfFileName,
            SampleList: [objSampleData]
          }
          ReportData.push(objData);
        }
      } else {
        contractList.push(item.axContractId);
        let arr = [item.tranformerName];
        tranformerList.push(arr);
        let objSampleData = {
          ...reportTotObjSample,
          SampleID: item.sampleControlNoCd,
          ReportsDescription: item.pdfFileName,
          ReportType: item.serviceType,
          ReportDate: item.reportDt,
          pdfFileName: item.pdfFileName,
          Flag: item.status
        }
        let objData = {
          ...reportObj,
          CustomerContract: item.axContractId,
          VesselName: item.tranformerName,
          Dispatchport: item.portName,
          BunkeredDate: item.reportDt,
          Status: item.status,
          pdfFileName: item.pdfFileName,
          SampleList: [objSampleData]
        }
        ReportData.push(objData);
      }

    })
    return ReportData;
  }

  /** sample DrillDown */
  const getSampleFualFormat = (data) => {
    debugger
    let contractList = [];
    let vesselList = [];
    let ReportData = [];
    (grouping == "false" ?
      data.map((item) => {
        // ////console.log(item,'item');
        let indexContract = contractList.indexOf(item.axContractId);

        // ////console.log(indexContract,'indexContract');
        if (indexContract > -1) {
          let indexVessel = vesselList[indexContract].indexOf(item.currentVesselName);
          // ////console.log(indexVessel,'indexVessel');
          // ////console.log(item.currentVesselName,'currentVesselName');
          if (indexVessel > -1) {
            let objSampleData = {
              ...sampleFualObjSample,
              SampleNumber: item.sampleControlNoCd,
              BunkerPort: item.portName,
              Vessel_Name: item.currentVesselName,
              FuelGrade: item.productType,
              ReportType: item.serviceType,
              SampledDate: item.samplingDt,
              ArrivedDate: item.arrivedOnDt,
              AnalysedDate: item.testedDt,
              ReportedDate: item.reportDt,
              Status: item.status
            }
            const objIndex = ReportData.findIndex((obj => obj.VesselName == item.currentVesselName));
            ReportData[objIndex].SampleList.push(objSampleData);

          } else {
            vesselList[indexContract].push(item.currentVesselName);
            let objSampleData = {
              ...sampleFualObjSample,
              SampleNumber: item.sampleControlNoCd,
              BunkerPort: item.portName,
              Vessel_Name: item.currentVesselName,
              FuelGrade: item.productType,
              ReportType: item.serviceType,
              SampledDate: item.samplingDt,
              ArrivedDate: item.arrivedOnDt,
              AnalysedDate: item.testedDt,
              ReportedDate: item.reportDt,
              Status: item.status
            }
            let objData = {
              ...sampleObj,
              CustomerContract: item.axContractId,
              VesselName: item.currentVesselName,
              Dispatchport: item.portName,
              SampledDate: item.samplingDt,
              Status: item.status,
              CustomerName: item.customerName,
              SampleList: [objSampleData]
            }
            ReportData.push(objData);
          }
        } else {
          contractList.push(item.axContractId);
          let arr = [item.currentVesselName];
          vesselList.push(arr);
          let objSampleData = {
            ...sampleFualObjSample,
            SampleNumber: item.sampleControlNoCd,
            BunkerPort: item.portName,
            Vessel_Name: item.currentVesselName,
            FuelGrade: item.productType,
            ReportType: item.serviceType,
            SampledDate: item.samplingDt,
            ArrivedDate: item.arrivedOnDt,
            AnalysedDate: item.testedDt,
            ReportedDate: item.reportDt,
            Status: item.status
          }
          let objData = {
            ...sampleObj,
            CustomerContract: item.axContractId,
            VesselName: item.currentVesselName,
            Dispatchport: item.portName,
            SampledDate: item.samplingDt,
            Status: item.status,
            CustomerName: item.customerName,
            SampleList: [objSampleData]
          }
          ReportData.push(objData);
          console.log("Fuel", objData);
        }

      })
      : ReportData = data)

    return ReportData;
  }

  const getSampleLubeFormat = (data) => {

    let cList = [];
    let rdata1 = [];

    data.map((item) => {
      console.log(item);
      if (cList.indexOf(item.axContractId + "_" + item.currentVesselName) == -1)
        cList.push(item.axContractId + "_" + item.currentVesselName);
    });
    debugger
    (grouping == "false" ?
      cList.map((item) => {
        let filterData = data.filter(dataitem => dataitem.axContractId + "_" + dataitem.currentVesselName == item);
        let reportObj = {
          CustomerContract: filterData[0].axContractId,
          CustomerName: filterData[0].customerName,
          Dispatchport: "",
          SampledDate: "",
          Status: "",
          VesselName: filterData[0].imoNo,
          imoNo: filterData[0].currentVesselName,
          pdfFileName: "",
          SampleList: []
        }
        filterData.map((filterItem) => {
          let SampleListObj = {
            SampleID: filterItem.sampleControlNoCd,
            ServiceType: filterItem.serviceType,
            SampledDate: filterItem.samplingDt,
            ArrivedDate: filterItem.arrivedOnDt,
            AnalysedDate: filterItem.testedDt,
            ReportedDate: filterItem.reportDt,
            EquipmentDescription: filterItem.equipmentDescription,
            Status: filterItem.status
          }
          reportObj.SampleList.push(SampleListObj);
        });

        rdata1.push(reportObj);

      })
      : rdata1 = data)
    return rdata1;
  }




  const getSampleLubeFormatlube = (data) => {

    let cList = [];
    let rdata1 = [];
    data.map((item) => {
      if (cList.indexOf(item.axContractId + "_" + item.currentVesselName) == -1)
        cList.push(item.axContractId + "_" + item.currentVesselName);
    });
    cList.map((item) => {

      let filterData = data.filter(dataitem => dataitem.axContractId + "_" + dataitem.currentVesselName == item);
      let reportObj = {
        CustomerContract: filterData[0].axContractId,
        imoNo: filterData[0].currentVesselName,
        SampleListlube: [],
        CustomerName: filterData[0].customerName,
      }
      filterData.map((filterItem) => {
        let SampleListObj = {
          SampleNumber: filterItem.sampleControlNoCd,
          EquipmentDescription: filterItem.equipmentDescription,
          ServiceType: filterItem.serviceType,
          SampledDate: filterItem.samplingDt,
          ArrivedDate: filterItem.arrivedOnDt,
          AnalysedDate: filterItem.testedDt,
          ReportedDate: filterItem.reportDt,
          // EquipmentDescription: filterItem.equipmentDescription,
          Status: filterItem.status
        }
        reportObj.SampleListlube.push(SampleListObj);
      });

      rdata1.push(reportObj);

    });
    return rdata1;
  }
  const getSampleTotFormat = (data) => {
    let contractList = [];
    let tranformerList = [];
    let ReportData = [];
    (grouping == "false" ?
      data.map((item) => {
        let indexContract = contractList.indexOf(item.axContractId);
        if (indexContract > -1) {
          let indexTranformer = tranformerList[indexContract].indexOf(item.tranformerName);
          if (indexTranformer > -1) {
            let objSampleData = {
              ...sampleTotObjSample,
              SampleNumber: item.sampleControlNoCd,
              // EquipmentDescription:item.portName,
              AssetName: item.tranformerName,
              ServiceType: item.serviceType,
              SampledDate: item.samplingDt,
              ArrivedDate: item.arrivedOnDt,
              AnalysedDate: item.testedDt,
              ReportedDate: item.reportDt,
              Status: item.status
            }
            ReportData[indexTranformer].SampleList.push(objSampleData);
          } else {
            tranformerList[indexContract].push(item.tranformerName);
            let objSampleData = {
              ...sampleTotObjSample,
              SampleNumber: item.sampleControlNoCd,
              // EquipmentDescription:item.portName,
              AssetName: item.tranformerName,
              ServiceType: item.serviceType,
              SampledDate: item.samplingDt,
              ArrivedDate: item.arrivedOnDt,
              AnalysedDate: item.testedDt,
              ReportedDate: item.reportDt,
              Status: item.status
            }
            let objData = {
              ...sampleObj,
              CustomerContract: item.axContractId,
              VesselName: item.tranformerName,
              Dispatchport: item.portName,
              SampledDate: item.samplingDt,
              Status: item.status,
              CustomerName: item.customerName,
              SampleList: [objSampleData]
            }
            ReportData.push(objData);

          }
        } else {
          contractList.push(item.axContractId);
          let arr = [item.tranformerName];
          tranformerList.push(arr);
          let objSampleData = {
            ...sampleTotObjSample,
            SampleNumber: item.sampleControlNoCd,
            // EquipmentDescription:item.portName,
            AssetName: item.tranformerName,
            ServiceType: item.serviceType,
            SampledDate: item.samplingDt,
            ArrivedDate: item.arrivedOnDt,
            AnalysedDate: item.testedDt,
            ReportedDate: item.reportDt,
            Status: item.status
          }
          let objData = {
            ...sampleObj,
            CustomerContract: item.axContractId,
            VesselName: item.tranformerName,
            Dispatchport: item.portName,
            SampledDate: item.samplingDt,
            Status: item.status,
            CustomerName: item.customerName,
            SampleList: [objSampleData]
          }
          ReportData.push(objData);
          console.log("Tot", objData);
        }

      })
      ////console.log(ReportData,"ReportData")
      : ReportData = data)
    return ReportData;
  }


  /** DrillDown Grouping E*/


  /** Tab action events S */

  const tabSampleActive = (index) => {
debugger
    //
    ////console.log(index, "sample-index", reporSubType);
    setSampleFormatActive(sampleDetailsListTotal[index]);
    if (index == 0) {
      settabName("Fuel")
      setReporSubType("Fuel");
      /* setFormObj(sampleFilterFual); */
      filterSampleFuel(IntialFuelLoadEffect())
      //filterSampleFuel(sampleFilterFual);
      //getReportFualDrillDown("Report/FuelAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Fuel");
    } if (index == 1) {
      setReporSubType("Lube");
      settabName("Lube")
      filterSampleLube(IntialLubeLoadEffect())
      /* setFormObj(sampleFilterLube);
      filterSampleLube(sampleFilterLube);
      getReportFualDrillDown("Report/LubeAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Lube"); */
    } if (index == 2) {
      setReporSubType("Tot");
      settabName("Tot")
      filterSampleTot(IntialTotLoadEffect())
      /* setFormObj(sampleFilterTOT);
      filterSampleTot(sampleFilterTOT);
      getReportFualDrillDown("Report/ToTAnalysis/SampleStatus/DrillDown", getCookie("clientId"), "Tot"); */
    }
  }
  const tabReportActive = (index) => {
    ////console.log(index, "report-index");

    if (filterStatus) {
      setFilterStatus(false);
      getReports(getCookie("clientId"));
    }
    setReportFormatActive(reportDetailsListTotal[index]);
    if (index == 0) {
      setReporSubType("Fuel");
      getReportFualDrillDown("Report/FuelAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Fuel");
    } if (index == 1) {
      setReporSubType("Lube");
      getReportFualDrillDown("Report/LubeAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Lube");
    } if (index == 2) {
      setReporSubType("Tot");
      getReportFualDrillDown("Report/ToTAnalysis/ReportStatus/DrillDown", getCookie("clientId"), "Tot");
    }
  }
  /** Tab action events E */

  const getReports = async (customerKeys) => {
    ////
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/Dashboard`;

    const data = {
      "CustomerKeys": customerKeys,
      // "StartDate": "2020-12-01",
      // "EndDate": "2022-01-01"

      "FuelStartDate": getcurrentDateByReportSubType("Fuel"),
      "FuelEndDate": getCurrentDate(),
      "LubeStartDate": getcurrentDateByReportSubType("Lube"),
      "LubeEndDate": getCurrentDate(),
      "TotStartDate": getcurrentDateByReportSubType("Tot"),
      "TotEndDate": getCurrentDate()
    }
    await postRequest(url, data)
      .then((res) => {
        ////console.log(res);
        const result = res.data;
        const objData = {
          fuelAnalysisReportStatus: getReportData(res.data.fuelAnalysisReportStatus),
          lubeAnalysisReportStatus: getReportData(res.data.lubeAnalysisReportStatus),
          totAnalysisReportStatus: getReportData(res.data.totAnalysisReportStatus),
          fuelAnalysisSampleStatus: getSampleData(res.data.fuelAnalysisSampleStatus),
          lubeAnalysisSampleStatus: getSampleData(res.data.lubeAnalysisSampleStatus),
          totAnalysisSampleStatus: getSampleData(res.data.totAnalysisSampleStatus)
        }
        const objTotalData = [];
        objTotalData.push(getReportTotalData(res.data.fuelAnalysisReportStatus));
        objTotalData.push(getReportTotalData(res.data.lubeAnalysisReportStatus));
        objTotalData.push(getReportTotalData(res.data.totAnalysisReportStatus));
        const objTotalSampleData = [];
        objTotalSampleData.push(getSampleTotalData(res.data.fuelAnalysisSampleStatus));
        objTotalSampleData.push(getSampleTotalData(res.data.lubeAnalysisSampleStatus));
        objTotalSampleData.push(getSampleTotalData(res.data.totAnalysisSampleStatus));

        setReportFormatActive(getReportTotalData(
          reporSubType == "Tot" ? res.data.totAnalysisReportStatus :
            reporSubType == "Fuel" ? res.data.fuelAnalysisReportStatus :
              res.data.lubeAnalysisReportStatus
        ));
        setSampleFormatActive(getSampleTotalData(
          reporSubType == "Tot" ? res.data.totAnalysisSampleStatus :
            reporSubType == "Fuel" ? res.data.fuelAnalysisSampleStatus :
              res.data.lubeAnalysisSampleStatus));

        setReportDetailsListTotal(objTotalData);
        setSampleDetailsListTotal(objTotalSampleData);
        setReportDetailsList(objData);
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  }
  /** Active Tab of format right side S */
  const getReportData = (data) => {
    let analysList = [];
    let analysServiceList = [];
    let analysStatusList = [];
    let max = 0;
    data.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });
    max = max + 30;
    data.map((row, index) => {
      ////console.log(index, row);
      const reportIndex = analysServiceList.indexOf(row.serviceType.trim());
      if (reportIndex > -1) {
        const IndexForStatus = analysStatusList[reportIndex].indexOf(row.status);
        if (IndexForStatus > -1) {
          const samplePipeData = {
            "title": row.status,
            "color": ReportStatusColor[IndexForStatus],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        } else {
          analysStatusList[reportIndex].push(row.status);
          const analysStatusListIndex = analysStatusList[reportIndex].indexOf(row.status);
          const samplePipeData = {
            "title": row.status,
            "color": ReportStatusColor[analysStatusListIndex],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        }
      } else {
        analysServiceList.push(row.serviceType.trim());
        const IndexForStatus = analysServiceList.indexOf(row.serviceType.trim());
        const arrStatus = [];
        arrStatus.push(row.status)
        analysStatusList[IndexForStatus] = arrStatus;
        const analysStatusListIndex = analysStatusList[IndexForStatus].indexOf(row.status);
        const samplePipeData = {
          "title": row.status,
          "color": ReportStatusColor[analysStatusListIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        }
        let SampleStatusFormatData = [];
        SampleStatusFormatData.push(samplePipeData);
        const SampleStatusDataEdit = { ...SampleStatusData, caseCount: row.samplesCount, title: row.serviceType, typeOfCase: SampleStatusFormatData }
        analysList.push(SampleStatusDataEdit);
      }
    })
    return analysList;
  }
  const getSampleData = (data) => {
    let analysList = [];
    let analysServiceList = [];
    let analysStatusList = [];
    let max = 0;
    data.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });
    max = max + 30;
    data.map((row, index) => {
      ////console.log(index, row);
      const reportIndex = analysServiceList.indexOf(row.serviceType.trim());
      if (reportIndex > -1) {
        const IndexForStatus = analysStatusList[reportIndex].indexOf(row.status);
        if (IndexForStatus > -1) {
          const samplePipeData = {
            "title": row.status,
            "color": SampleStatusColor[IndexForStatus],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        } else {
          analysStatusList[reportIndex].push(row.status);
          const analysStatusListIndex = analysStatusList[reportIndex].indexOf(row.status);
          const samplePipeData = {
            "title": row.status,
            "color": SampleStatusColor[analysStatusListIndex],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        }
      } else {
        analysServiceList.push(row.serviceType.trim());
        const IndexForStatus = analysServiceList.indexOf(row.serviceType.trim());
        const arrStatus = [];
        arrStatus.push(row.status)
        analysStatusList[IndexForStatus] = arrStatus;
        const analysStatusListIndex = analysStatusList[IndexForStatus].indexOf(row.status);
        const samplePipeData = {
          "title": row.status,
          "color": SampleStatusColor[analysStatusListIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        }
        let SampleStatusFormatData = [];
        SampleStatusFormatData.push(samplePipeData);
        const SampleStatusDataEdit = { ...SampleStatusData, caseCount: row.samplesCount, title: row.serviceType, typeOfCase: SampleStatusFormatData }
        analysList.push(SampleStatusDataEdit);
      }
    })
    return analysList;
  }
  /** Active Tab of format right side E */

  /** Active Tab of  format  left side S */
  const getReportTotalData = (data) => {
    let analysList = [];
    let analysStatusList = [];
    let countCase = 0;
    let max = 0;
    data.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });
    max = max + 30;
    data.map((row, index) => {
      ////console.log(row);
      let analysIndex = analysStatusList.indexOf(row.status);
      if (analysIndex > -1) {
        countCase = countCase + row.samplesCount;
        analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
      } else {
        analysStatusList.push(row.status);
        let rIndex = analysStatusList.indexOf(row.status);
        countCase = countCase + row.samplesCount;
        analysList.push({
          "title": row.status,
          "color": ReportStatusColor[rIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        })
      }
    })
    return { ...TotalReportStatusData, caseCount: countCase, typeOfCase: analysList };
  }
  const getSampleTotalData = (data) => {
    let analysList = [];
    let analysStatusList = [];
    let countCase = 0;
    let max = 0;
    data.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });

    max = max + 30;
    data.map((row, index) => {
      ////console.log(row);
      let analysIndex = analysStatusList.indexOf(row.status);
      if (analysIndex > -1) {
        countCase = countCase + row.samplesCount;
        analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
      } else {
        countCase = countCase + row.samplesCount;
        analysStatusList.push(row.status);
        let rIndex = analysStatusList.indexOf(row.status);
        analysList.push({
          "title": row.status,
          "color": SampleStatusColor[rIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        })
      }
    })
    return { ...TotalSampleStatusData, caseCount: countCase, typeOfCase: analysList };

  }
  /** Tab Active format  left side E */

  const selectAllCheckbox = (event) => {
    setSelectedRowCount(!selectedRowCount);
    if (event.target.checked) {
      reportTableData.map((item) => {
        item.checked = true;
        if (item.checked) {
          item.subReportDetails.map((i) => {
            i.checked = true;
          });
        } else {
          item.subReportDetails.map((i) => {
            i.checked = false;
          });
        }
      });
    } else {
      reportTableData.map((item) => {
        item.checked = false;
        if (item.checked) {
          item.subReportDetails.map((i) => {
            i.checked = true;
          });
        } else {
          item.subReportDetails.map((i) => {
            i.checked = false;
          });
        }
      });
    }

    // setReportTableData(reportTableData);
    setmoment(Math.random() * 1000);
  };
  const updateReportTableData = (data) => {
    let selectedData = data.filter((item) => item.checked == true);
    if (selectedData.length == data.length) {
      setSelectedRowCount(1);
    } else {
      setSelectedRowCount(0);
    }
    setReportTableData(data);
    setmoment(Math.random() * 1000);
  };

  /** Down load PDF file S*/
  const getDownload = (data) => {
    ////console.log(data);
    if (data.pdfFileName) {
      dispatch({ type: LOADING, payload: true });
      const token = getCookie("token");
      let fileName = data.pdfFileName;
      if (data.pdfFileName.indexOf("\\") > -1) {
        fileName = data.pdfFileName.split("\\")[1];
      }
      const url =
        process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/file`;
      let filedata = JSON.stringify({ fileName: fileName });
      let config = {
        method: "post",
        responseType: "blob",
        url: url,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/pdf"
        },
        data: filedata,
      };
      axios(config)
        .then(async function (response) {
          if (response.status == 200) {
            dispatch({ type: LOADING, payload: false });
            const file = new Blob([response.data], { type: "application/pdf" });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);

            window.open(fileURL, '_blank')
            // window.location = fileURL;
          } else {
            ToastError(response.data.message);
          }
        })
        .catch(function (error) {
          dispatch({ type: LOADING, payload: false });
          ////console.log(error);
        });
    }
  }
  const [fName, setFName] = useState("");
  const [openpdf, setOpenpdf] = React.useState(false);
  const [pdfURL, setPdfURL] = useState("");
  const [openAlert, setOpenAlert] = React.useState(false);
  /** Down load PDF file E*/
  ////console.log(reportData, "reportData");
  //console.log(pdfURL)//[tableMeta.rowIndex]
  // const getRowPDFDownload = (row) => {
  //   //////console.log(data);
  //   ////
  //   const pdfFileName = row
  //   if (pdfFileName) {
  //     dispatch({ type: LOADING, payload: true });
  //     const token = getCookie("token");
  //     let fileName = pdfFileName;
  //     if (pdfFileName.indexOf("\\") > -1) {
  //       fileName = pdfFileName.split("\\")[1];
  //     }
  //     const url =
  //       process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/file`;
  //     let filedata = JSON.stringify({ fileName: fileName });
  //     let config = {
  //       method: "post",
  //       responseType: "blob",
  //       url: url,
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //         Accept: "application/pdf"
  //       },
  //       data: filedata,
  //     };
  //     axios(config)
  //       .then(async function (response) {
  //         if (response.status == 200) {
  //           dispatch({ type: LOADING, payload: false });
  //           const file = new Blob([response.data], { type: "application/pdf" });
  //           //Build a URL from the file
  //           const fileURL = URL.createObjectURL(file);
  //           setPdfURL(fileURL);
  //           //window.open(fileURL, '_blank')
  //           // window.location = fileURL;
  //         } else {
  //           ToastError(response.data.message);
  //         }
  //       })
  //       .catch(function (error) {
  //         dispatch({ type: LOADING, payload: false });
  //         ////console.log(error);
  //       });
  //   }
  // }
  // const getpdfName = (value) => {
  // setFName(value);
  // }

  // const getLubepdfName = (value) => {
  //   if(value.serviceType==="OCM"&& (value.EquipmentList).length=== 1){
  //     getpdfName(value.EquipmentList[0].Equipment+" ("+value.EquipmentList[0].SampleId+")-VPS OCM Report-"+value.reportDt)
  //   }else if(value.serviceType==="OCM"){
  //     getpdfName(value.ShipName+"-VPS OCM Report ("+(value.EquipmentList).length+" nos)_Rev1-"+value.reportDt)
  //   }else{
  //     getpdfName(value.ShipName+"-VPS SDA Report-"+value.reportDt)
  //   }
  //   }

  // const toggleRow = (row) => {
  //   ////
  //   /* setOpen(!open);
  //  if(!open && !pdfURL) */
  //   getRowPDFDownload(row)
  //   setOpenAlert(true);
  //   setOpenpdf(true)
  // }
  /** Down load PDF file E*/
  ////console.log(reportData,"reportData");
  // const getReportsColumn = (data) => {
  //   //console.log("rowData:", data);

  //   let additionalOAFile, AdditionalSPECFile, PDFFileName;
  //   PDFFileName = (data.pdfFileName != null ? getPDFButton(data) : <></>);
  //   additionalOAFile = (data.additionalOAFile != null ? getPDFButton1(data) : <></>);

  //   AdditionalSPECFile = (data.additionalSPECFile != null ? getPDFButton2(data) : <></>);


  //   return <div class="row">{PDFFileName}{additionalOAFile}{AdditionalSPECFile}</div>

  // }

  const getGridHeader = (reportSubTypeV) => {
    if (reportSubTypeV == "Fuel") {

      return [
        {
          name: "axContractId",
          label: "Customer Contract",
          options: {
            display: 'false',
            filter: false,
            sort: false,

          }
        },{
          name: "customerName",
          label: "Customer Name",
          options: {
            filter: true,
            sort: true,


          }
        }, {
          name: "currentVesselName",
          label: "Ship Name (IMO)",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "sampleControlNoCd",
          label: "Sample Number",
          options: {
            filter: true,
            sort: true,

          }
        },
        // {
        //   name: "currentVesselName",
        //   label: "Vessel Name",
        //   options: {
        //     filter: true,
        //     sort: true,

        //   }
        // },
        {
          name: "portName",
          label: "Bunker Port",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "productType",
          label: "Fuel Grade",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "serviceType",
          label: "Report Type",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "samplingDt",
          label: "Sampled Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "arrivedOnDt",
          label: "Arrived Date",
          options: {
            filter: true,
            sort: true,

          }
        },

        {
          name: "testedDt",
          label: "Analysed Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "reportDt",
          label: "Reported Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "status",
          label: "Status",
          options: {
            filter: true,
            sort: true,

          }
        }
      ];
    }
    else if (reportSubTypeV == "Lube") {
      return [
        {
          name: "axContractId",
          label: "Customer Contract",
          options: {
            display: 'false',
            filter: false,
            sort: false,

          }
        }, {
          name: "customerName",
          label: "Customer Name",
          options: {
            filter: true,
            sort: true,


          }
        }, {
          name: "currentVesselName",
          label: "Ship Name (IMO)",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "sampleControlNoCd",
          label: "Sample Number",
          options: {
            filter: true,
            sort: true,

          }
        },

        {
          name: "equipmentDescription",
          label: "Equipment Description",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "serviceType",
          label: "Service Type",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "samplingDt",
          label: "Sampled Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "arrivedOnDt",
          label: "Arrived Date",
          options: {
            filter: true,
            sort: true,

          }
        },

        {
          name: "testedDt",
          label: "Analysed Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "reportDt",
          label: "Reported Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "status",
          label: "Status",
          options: {
            filter: true,
            sort: true,

          }
        }
      ];
    } else if (reportSubTypeV == "Tot") {
      return [

        {
          name: "axContractId",
          label: "Customer Contract",
          options: {
            display: 'false',
            filter: false,
            sort: false,

          }
        }, {
          name: "customerName",
          label: "Customer Name",
          options: {
            filter: true,
            sort: true,


          }
        }, {
          name: "tranformerName",
          label: "Asset Name",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "sampleControlNoCd",
          label: "Sample Number",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "serviceType",
          label: "Service Type",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "samplingDt",
          label: "Sampled Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "arrivedOnDt",
          label: "Arrived Date",
          options: {
            filter: true,
            sort: true,

          }
        },

        {
          name: "testedDt",
          label: "Analysed Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "reportDt",
          label: "Reported Date",
          options: {
            filter: true,
            sort: true,

          }
        },
        {
          name: "status",
          label: "Status",
          options: {
            filter: true,
            sort: true,

          }
        }
      ];
    }
  }

  const getGridHeader2 = (reportSubTypeV) => {
    if (reportSubTypeV == "Fuel") {
      if (reportData) { }
      return [
        {
          name: "CustomerContract",
          label: "Customer Contract",
          options: {
            display: 'false',
            filter: false,
            sort: false,
          }
        }, 
        {
          name: "CustomerName",
          label: "Customer Name",
          options: {
            filter: true,
            sort: true,


          }
        }, {
          name: "VesselName",
          label: "Ship Name (IMO)",
          options: {
            filter: true,
            sort: true,

          }
        },


      ];
    } else if (reportSubTypeV == "Lube") {
      return [
        {
          name: "CustomerContract",
          label: "Customer Contract",
          options: {
            display: 'false',
            filter: false,
            sort: false,

          }
        }, {
          name: "CustomerName",
          label: "Customer Name",
          options: {
            filter: true,
            sort: true,


          }
        }, {
          name: "imoNo",
          label: "Ship Name (IMO)",
          options: {
            filter: true,
            sort: true,

          }
        },

      ];
    } else if (reportSubTypeV == "Tot") {
      return [

        {
          name: "CustomerContract",
          label: "Customer Contract",
          options: {
            display: 'false',
            filter: false,
            sort: false,

          }
        }, {
          name: "CustomerName",
          label: "Customer Name",
          options: {
            filter: true,
            sort: true,


          }
        }, {
          name: "VesselName",
          label: "Asset Name",
          options: {
            filter: true,
            sort: true,

          }
        },
      ];
    }
  }
  const [tab, setTab] = React.useState();
  const getChangedTab = (t) => {
    setTab(t);
  }
  const onRowClick = () => {
    ////
  }
  let expandrows = false;

  if (reporSubType == "Lube") {
    expandrows = true;
  }
  if (reporSubType == "Fuel") {
    expandrows = true;
  }
  if (reporSubType == "Tot") {
    expandrows = true;
  }

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    if (filterChip === true) {
      props.filterList.length = 0;
      setFilterChip(false)
    }
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  // const SchedulerGrouping = () => {
  //   if(grouping){
  //   setGrouping(false);
  //   } else{
  //     setGrouping(true);
  //   }
  // }

  const toolTipValue = () => {
    //
    if (grouping) {
      return "Ungrouping"
    } else {
      return "Grouping"
    }
  }

  const clear = () => (
    <Tooltip disableFocusListener title={toolTipValue()} >
      <IconButton disabled /*onClick={SchedulerGrouping}*/ className={classes.btnStyle3} >
        {grouping == "true" ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
      </IconButton>
    </Tooltip>
  );
  const options = {
    customToolbarSelect: () => {
      <>
        onRowsDelete:true,
      </>

    },
    customToolbar: clear,
    selectToolbarPlacement: "above",
    selectableRows: "multiple",
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    filter: true,
    filterType: 'multiselect',
    responsive: 'standard',
    expandableRows: grouping == "false" ? expandrows : "",
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    download: true,
    downloadOptions: {
      filename: "tableDownload.csv",
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true
      }
    },

    onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      //debugger
      //console.log("reportlube", reportDatalube[]);
      let isExistLube = [];
      let isExistFuel = [];
      let isExistTot = [];
      let isExistLubegrp = [];
      rowsSelected.forEach((d) => {
        isExistLube.push(reportDatalube[d]);
        isExistLubegrp.push(reportData[d]);
        isExistFuel.push(reportData[d]);
        console.log(isExistFuel);
        isExistTot.push(reportData[d]);

      })
      // console.log("isExistLube", isExistLube)
      // console.log("isExistFuel", isExistFuel)
      // console.log("isExistTot", isExistTot)
      //console.log("shiva",isExist)
      setSelectedReportDatalube(isExistLube);
      setSelectedReportDatalubegrp(isExistLubegrp)
      setSelectedReportDataFuel(isExistFuel);
      setSelectedReportDataTot(isExistTot);
    },

    onDownload: (buildHead, buildBody, columns, gridData, rowData) => {
      if (grouping == "false") {
        if (reporSubType == "Lube") {
          var myData = [];
          var newKeys = Object.keys(reportDatalube[0].SampleListlube[0]);
          var idx = 0;
          ////;
          console.log("Ddata", gridData);
          var columnsExport = [];
          var dataExport = [];
          columnsExport.push(" ");
          columns.forEach((cl) => {
            if(cl.label!=="Customer Contract"){
            columnsExport.push(cl.label);
            }
          })
          newKeys.forEach((k) => {
            columnsExport.push(k);
          });
          columnsExport.push("\n");
          let i = 0;
          //debugger
          //console.log(selectedreportDatalube,selectedreportDatalube.length)
          selectedreportDatalube.length > 0 ?
            (
              selectedreportDatalube.forEach((item) => {
                //debugger
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.CustomerContract && dfdt[2] == item.imoNo)
                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {
                  let itemData = { CustomerName: item.CustomerName, imoNo: item.imoNo, SampleListlube: item.SampleListlube };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++;

                  let itemEquipments = itemData.SampleListlube.map(a => { return { ...a } });
                  //itemData.CustomerContract = itemData.CustomerContract.trim() == "" ? "  " : itemData.CustomerContract;
                  // delete itemData.CustomerContract;
                  //delete itemData.imoNo;
                  delete itemData.SampleListlube;
                  itemEquipments.forEach((ie, idx) => {
                    //let di={index:idx++,data:[]}
                    ie.AnalysedDate = ie.AnalysedDate ? ie.AnalysedDate : "";
                    ie.ArrivedDate = ie.ArrivedDate ? ie.ArrivedDate : "";
                    ie.ReportedDate = ie.ReportedDate ? ie.ReportedDate : "";
                    ie.SampledDate = ie.SampledDate ? ie.SampledDate : "";
                    let data = [];
                    data.push(...Object.values({ ...itemData, ...ie }));
                    data.push("\n");
                    dataItem.push(data);
                  });
                  myData.push(...dataItem);
                }
              })
            ) : (
              reportDatalube.forEach((item) => {
                debugger
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.CustomerContract && dfdt[2] == item.imoNo)
                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {
                  let itemData = { CustomerName: item.CustomerName, imoNo: item.imoNo, SampleListlube: item.SampleListlube };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++;

                  let itemEquipments = itemData.SampleListlube.map(a => { return { ...a } });
                  // itemData.CustomerContract = itemData.CustomerContract.trim() == "" ? "  " : itemData.CustomerContract;
                  // delete itemData.CustomerContract;
                  // //delete itemData.imoNo;
                  delete itemData.SampleListlube;
                  itemEquipments.forEach((ie, idx) => {
                    //let di={index:idx++,data:[]}
                    ie.AnalysedDate = ie.AnalysedDate ? ie.AnalysedDate : "";
                    ie.ArrivedDate = ie.ArrivedDate ? ie.ArrivedDate : "";
                    ie.ReportedDate = ie.ReportedDate ? ie.ReportedDate : "";
                    ie.SampledDate = ie.SampledDate ? ie.SampledDate : "";
                    let data = [];
                    data.push(...Object.values({ ...itemData, ...ie }));
                    data.push("\n");
                    dataItem.push(data);
                  });
                  myData.push(...dataItem);
                }
              })
            )
          buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
          }
          buildBody = () => {
            console.log(myData);
            return myData;
          }
          return buildHead() + buildBody();
        }
        else if (reporSubType == "Fuel") {
          //
          var myData = [];
          var newKeys = Object.keys(reportData[0].SampleList[0]);
          var idx = 0;
          //;
          console.log("Ddata", gridData);
          var columnsExport = [];
          var dataExport = [];
          columnsExport.push("");
          columns.forEach((cl) => {
            if(cl.label!=="Customer Contract"){
              columnsExport.push(cl.label);
            }
            

          })
          newKeys.forEach((k) => {
            if (k !== "Vessel_Name"){
              columnsExport.push(k);
            }
            
          });
          columnsExport.push("\n");
          let i = 0;;
          selectedreportDataFuel.length > 0 ?
            (
              selectedreportDataFuel.forEach((item) => {
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.CustomerContract && dfdt[2] == item.VesselName)
                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {
                  //
                  let itemData = { CustomerName: item.CustomerName, VesselName: item.VesselName, SampleList: item.SampleList };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++;

                  let itemEquipments = itemData.SampleList.map(a => { return { ...a } });
                  //itemData.CustomerContract = itemData.CustomerContract.trim() == "" ? "  " : itemData.CustomerContract;
                  delete itemData.SampleList;
                  // delete itemData.SampledDate;
                  // delete itemData.Status;
                  // delete itemData.pdfFileName;
                  // delete itemData.Dispatchport;
                  // //delete itemData.VesselName;

                  // delete itemData.SampleList;
                  itemEquipments.forEach((ie, idx) => {
                    delete ie.Vessel_Name;
                    ie.BunkerPort = ie.BunkerPort.replace(/,/g, "");
                    ie.AnalysedDate = ie.AnalysedDate ? ie.AnalysedDate : "";
                    ie.ArrivedDate = ie.ArrivedDate ? ie.ArrivedDate : "";
                    ie.ReportedDate = ie.ReportedDate ? ie.ReportedDate : "";
                    ie.SampledDate = ie.SampledDate ? ie.SampledDate: "";
                    //let di={index:idx++,data:[]}
                    let data = [];
                    data.push(...Object.values({ ...itemData, ...ie }));
                    data.push("\n");
                    dataItem.push(data);
                  });
                  myData.push(...dataItem);
                }
              })
            ) : (
              reportData.forEach((item) => {
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.CustomerContract && dfdt[2] == item.VesselName)
                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {
                  //
                  let itemData = { CustomerName: item.CustomerName, VesselName: item.VesselName, SampleList: item.SampleList };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++;

                  let itemEquipments = itemData.SampleList.map(a => { return { ...a } });
                  //itemData.CustomerContract = itemData.CustomerContract.trim() == "" ? "  " : itemData.CustomerContract;
                  delete itemData.SampleList;
                  // delete itemData.SampledDate;
                  // delete itemData.Status;
                  // delete itemData.pdfFileName;
                  // delete itemData.Dispatchport;
                  // //delete itemData.VesselName;

                  // delete itemData.SampleList;
                  itemEquipments.forEach((ie, idx) => {
                    delete ie.Vessel_Name;
                    ie.BunkerPort = ie.BunkerPort.replace(/,/g, "");
                    ie.AnalysedDate = ie.AnalysedDate ? ie.AnalysedDate : "";
                    ie.ArrivedDate = ie.ArrivedDate ? ie.ArrivedDate : "";
                    ie.ReportedDate = ie.ReportedDate ? ie.ReportedDate : "";
                    ie.SampledDate = ie.SampledDate ? ie.SampledDate : "";
                    //let di={index:idx++,data:[]}
                    let data = [];
                    data.push(...Object.values({ ...itemData, ...ie }));
                    data.push("\n");
                    dataItem.push(data);
                  });
                  myData.push(...dataItem);
                }
              })
            )

          buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
          }
          buildBody = () => {
            console.log(myData);
            return myData;
          }
          return buildHead() + buildBody();
        }

        else if (reporSubType == "Tot") {
          //
          var myData = [];
          var newKeys = Object.keys(reportData[0].SampleList[0]);
          var idx = 0;
          // //;
          console.log("Ddata", gridData);
          var columnsExport = [];
          var dataExport = [];
          columnsExport.push("");
          columns.forEach((cl) => {
            if (cl.label == "Customer Name"){
            columnsExport.push(cl.label);
            }
          })
          newKeys.forEach((k) => {
            columnsExport.push(k);
          });
          //delete columnsExport[3];
          columnsExport.push("\n");
          let i = 0;
          selectedreportDataTot.length > 0 ?
            (
              selectedreportDataTot.forEach((item) => {
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.CustomerContract && dfdt[2] == item.VesselName)
                    return true;
                  else
                    return false;

                });

                if (visibleRows.length > 0) {
                  //
                  let itemData = { ...item };

                  let dataItem = []

                  if (i == 0)
                    dataItem.push("");
                  i++;

                  let itemEquipments = itemData.SampleList.map(a => { return { ...a } });
                  itemData.CustomerContract = itemData.CustomerContract.trim() == "" ? "  " : itemData.CustomerContract;
                  itemData.VesselName = itemData.VesselName.replace(/,/g, "");
                  delete itemData.CustomerContract;
                  delete itemData.Dispatchport;
                  delete itemData.SampledDate;
                  delete itemData.Status;
                  delete itemData.pdfFileName;
                  //delete itemData.Dispatchport;
                  delete itemData.VesselName;
                  delete itemData.SampleList;

                  itemEquipments.forEach((ie, idx) => {
                    //let di={index:idx++,data:[]}
                    //;
                    let data = [];
                    ie.AssetName = ie.AssetName.replace(/,/g, "");
                    ie.AnalysedDate = ie.AnalysedDate ? ie.AnalysedDate : "";
                    ie.ArrivedDate = ie.ArrivedDate ? ie.ArrivedDate : "";
                    ie.ReportedDate = ie.ReportedDate ? ie.ReportedDate : "";
                    ie.SampledDate = ie.SampledDate ? ie.SampledDate : "";
                    data.push(...Object.values({ ...itemData, ...ie }));
                    data.push("\n");
                    dataItem.push(data);
                  });
                  myData.push(...dataItem);
                }

              })
            ) : (
              reportData.forEach((item) => {
                debugger
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.CustomerContract && dfdt[2] == item.VesselName)
                    return true;
                  else
                    return false;

                });

                if (visibleRows.length > 0) {
                  //
                  let itemData = { ...item };

                  let dataItem = []

                  if (i == 0)
                    dataItem.push("");
                  i++;

                  let itemEquipments = itemData.SampleList.map(a => { return { ...a } });
                  itemData.CustomerContract = itemData.CustomerContract.trim() == "" ? "  " : itemData.CustomerContract;
                  itemData.VesselName = itemData.VesselName.replace(/,/g, "");
                  delete itemData.CustomerContract;
                  delete itemData.Dispatchport;
                  delete itemData.SampledDate;
                  delete itemData.Status;
                  delete itemData.pdfFileName;
                  //delete itemData.Dispatchport;
                  delete itemData.VesselName;
                  delete itemData.SampleList;

                  itemEquipments.forEach((ie, idx) => {
                    //let di={index:idx++,data:[]}
                    //;
                    let data = [];
                    ie.AssetName = ie.AssetName.replace(/,/g, "");
                    ie.AnalysedDate = ie.AnalysedDate ? ie.AnalysedDate : "";
                    ie.ArrivedDate = ie.ArrivedDate ? ie.ArrivedDate : "";
                    ie.ReportedDate = ie.ReportedDate ? ie.ReportedDate : "";
                    ie.SampledDate = ie.SampledDate ? ie.SampledDate : "";
                    data.push(...Object.values({ ...itemData, ...ie }));
                    data.push("\n");
                    dataItem.push(data);
                  });
                  myData.push(...dataItem);
                }

              })
            )

          buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
          }
          buildBody = () => {
            console.log(myData);
            return myData;
          }
          return buildHead() + buildBody();
        }
      }
      else {
        if (reporSubType == "Fuel") {
          //
          var myData = [];
          //var newKeys = Object.keys(reportData[0].SampleList[0]);
          //var idx = 0;
          //;
          console.log("Ddata", gridData);
          var columnsExport = [];
          var dataExport = [];
          columnsExport.push("");
          columns.forEach((cl) => {
            if(cl.label!=="Customer Contract"){
            columnsExport.push(cl.label);
            }

          })
          // newKeys.forEach((k) => {
          //   columnsExport.push(k);
          // });
          columnsExport.push("\n");
          let i = 0;;
          selectedreportDataFuel.length > 0 ?
            (
              selectedreportDataFuel?.forEach((item) => {

                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  console.log(dfdt)
                  if (dfdt[0] == item.axContractId && dfdt[3] == item.sampleControlNoCd)

                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {

                  let itemData = { ...item };
                  console.log(itemData);
                  let dataItem = []

                  if (i == 0)
                    dataItem.push("");
                  i++;

                  itemData.portName = itemData.portName.replace(/,/g, "");
                  itemData.customerName = itemData.customerName.replace(/,/g, "");
                  let objReportfuel = {
                    customerName: itemData.customerName,
                    currentVesselName: itemData.currentVesselName,
                    sampleControlNoCd: itemData.sampleControlNoCd,
                    // VesselName: itemData.currentVesselName,
                    portName: itemData.portName,
                    productType: itemData.productType,
                    serviceType: itemData.serviceType,
                    samplingDt: itemData.samplingDt,
                    arrivedOnDt: itemData.arrivedOnDt,
                    testedDt: itemData.testedDt,
                    reportDt: itemData.reportDt,
                    status: itemData.status,
                  }
                  let data = [];
                  data.push(...Object.values({ ...objReportfuel }));
                  data.push("\n");
                  dataItem.push(data);
                  // });
                  myData.push(...dataItem);
                  console.log("myData", myData)
                }
              })
            ) : (

              reportData.forEach((item) => {
                debugger
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.axContractId && dfdt[3] == item.sampleControlNoCd)
                    return true;
                  else
                    return false;

                });


                if (visibleRows.length > 0) {

                  let itemData = { ...item };
                  let dataItem = []

                  if (i == 0)
                    dataItem.push("");
                  i++;

                  itemData.portName = itemData.portName.replace(/,/g, "");
                  itemData.customerName = itemData.customerName.replace(/,/g, "");
                  let objReportfuel = {
                    customerName: itemData.customerName,
                    currentVesselName: itemData.currentVesselName,
                    sampleControlNoCd: itemData.sampleControlNoCd,
                    // VesselName: itemData.currentVesselName
                    portName: itemData.portName,
                    productType: itemData.productType,
                    serviceType: itemData.serviceType,
                    samplingDt: itemData.samplingDt,
                    arrivedOnDt: itemData.arrivedOnDt,
                    testedDt: itemData.testedDt,
                    reportDt: itemData.reportDt,
                    status: itemData.status,
                  }
                  let data = [];
                  data.push(...Object.values({ ...objReportfuel }));
                  data.push("\n");
                  dataItem.push(data);
                  // });
                  myData.push(...dataItem);
                }
              })

            )
          buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
          }
          buildBody = () => {
            // console.log(myData);
            return myData;
          }
          return buildHead() + buildBody();
        }
        if (reporSubType == "Lube") {
          //
          var myData = [];
          //var newKeys = Object.keys(reportData[0].SampleList[0]);
          //var idx = 0;
          //;
          console.log("Ddata", gridData);
          var columnsExport = [];
          var dataExport = [];
          columnsExport.push("");
          columns.forEach((cl) => {
            if(cl.label!=="Customer Contract"){
            columnsExport.push(cl.label);
            }

          })
          // newKeys.forEach((k) => {
          //   columnsExport.push(k);
          // });
          columnsExport.push("\n");
          let i = 0;;
          selectedreportDatalubegrp.length > 0 ?
            (
              selectedreportDatalubegrp?.forEach((item) => {
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.axContractId && dfdt[3] == item.sampleControlNoCd)

                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {

                  let itemData = { ...item };
                  let dataItem = []

                  if (i == 0)
                    dataItem.push("");
                  i++;



                  let objReportlube = {
                    customerName: itemData.customerName,
                    currentVesselName: itemData.currentVesselName,
                    sampleControlNoCd: itemData.sampleControlNoCd,
                    equipmentDescription: item.equipmentDescription,
                    serviceType: itemData.serviceType,
                    samplingDt: itemData.samplingDt,
                    arrivedOnDt: itemData.arrivedOnDt,
                    testedDt: itemData.testedDt,
                    reportDt: itemData.reportDt,
                    status: itemData.status,
                  }
                  let data = [];
                  data.push(...Object.values({ ...objReportlube }));
                  data.push("\n");
                  dataItem.push(data);
                  // });
                  myData.push(...dataItem);
                  console.log("myData", myData)
                }
              })
            ) : (

              reportData.forEach((item) => {
                debugger
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.axContractId && dfdt[3] == item.sampleControlNoCd)
                    return true;
                  else
                    return false;

                });


                if (visibleRows.length > 0) {

                  let itemData = { ...item };
                  let dataItem = []

                  if (i == 0)
                    dataItem.push("");
                  i++;


                  let objReportlube = {
                    customerName: itemData.customerName,
                    currentVesselName: itemData.currentVesselName,
                    sampleControlNoCd: itemData.sampleControlNoCd,
                    equipmentDescription: item.equipmentDescription,
                    serviceType: itemData.serviceType,
                    samplingDt: itemData.samplingDt,
                    arrivedOnDt: itemData.arrivedOnDt,
                    testedDt: itemData.testedDt,
                    reportDt: itemData.reportDt,
                    status: itemData.status,
                  }
                  let data = [];
                  data.push(...Object.values({ ...objReportlube }));
                  data.push("\n");
                  dataItem.push(data);
                  // });
                  myData.push(...dataItem);
                }
              })

            )
          buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
          }
          buildBody = () => {
            // console.log(myData);
            return myData;
          }
          return buildHead() + buildBody();
        }
        if (reporSubType == "Tot") {
          //
          var myData = [];
          //var newKeys = Object.keys(reportData[0].SampleList[0]);
          //var idx = 0;
          //;
          console.log("Ddata", gridData);
          var columnsExport = [];
          var dataExport = [];
          columnsExport.push("");
          columns.forEach((cl) => {
            if(cl.label!=="Customer Contract"){
            columnsExport.push(cl.label);
            }
          })
          // newKeys.forEach((k) => {
          //   columnsExport.push(k);
          // });
          columnsExport.push("\n");
          let i = 0;;
          selectedreportDataTot.length > 0 ?
            (
              selectedreportDataTot?.forEach((item) => {
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.axContractId && dfdt[2] == item.tranformerName)

                    return true;
                  else
                    return false;
                });
                if (visibleRows.length > 0) {

                  let itemData = { ...item };

                  let dataItem = []

                  if (i == 0)
                    dataItem.push("");
                  i++;

                  itemData.tranformerName = itemData.tranformerName.replace(/,/g, "");

                  let objReportTot = {
                    customerName: itemData.customerName,
                    tranformerName: itemData.tranformerName,
                    sampleControlNoCd: itemData.sampleControlNoCd,
                    serviceType: itemData.serviceType,
                    samplingDt: itemData.samplingDt,
                    arrivedOnDt: itemData.arrivedOnDt,
                    testedDt: itemData.testedDt,
                    reportDt: itemData.reportDt,
                    status: itemData.status,
                  }
                  let data = [];
                  data.push(...Object.values({ ...objReportTot }));
                  data.push("\n");
                  dataItem.push(data);
                  // });
                  myData.push(...dataItem);
                  console.log("myData", myData)
                }
              })
            ) : (

              reportData.forEach((item) => {
                debugger
                //console.log(item);
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.axContractId && dfdt[2] == item.tranformerName)
                    return true;
                  else
                    return false;

                });


                if (visibleRows.length > 0) {

                  let itemData = { ...item };
                  let dataItem = []

                  if (i == 0)
                    dataItem.push("");
                  i++;
                  itemData.tranformerName = itemData.tranformerName.replace(/,/g, "");
                  let objReportTot = {
                    customerName: itemData.customerName,
                    tranformerName: itemData.tranformerName,
                    sampleControlNoCd: itemData.sampleControlNoCd,
                    serviceType: itemData.serviceType,
                    samplingDt: itemData.samplingDt,
                    arrivedOnDt: itemData.arrivedOnDt,
                    testedDt: itemData.testedDt,
                    reportDt: itemData.reportDt,
                    status: itemData.status,
                  }
                  let data = [];
                  data.push(...Object.values({ ...objReportTot }));
                  data.push("\n");
                  dataItem.push(data);
                  // });
                  myData.push(...dataItem);
                }
              })

            )
          buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
          }
          buildBody = () => {
            // console.log(myData);
            return myData;
          }
          return buildHead() + buildBody();
        }
      }
    },
    isRowExpandable: (dataIndex, expandedRows) => {

      // if (dataIndex === 3 || dataIndex === 4) return false;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (expandedRows.data.length < 0 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        return false;
      return true;

    },
    rowsExpanded: [],
    renderExpandableRow: (rowData, rowMeta) => {


      let expandeditem = reportData.filter((value) => {
        return value.imoNo === rowData[2]

      })
      console.log("expand", expandeditem);

      const colSpan = rowData.length + 1;

      let expandeditem1 = reportData.filter((value) => {
        return value.VesselName === rowData[2]
      })

      const colSpan1 = rowData.length + 1;

      let expandeditem2 = reportData.filter((value) => {
        return value.VesselName === rowData[2]
      })

      const colSpan2 = rowData.length + 1;
      return (
        <>

          {
            reporSubType == "Lube" ? (

              <TableRow>

                <TableCell colSpan={colSpan}>
                  <TableContainer component={Paper} className={clsx(classes.TableTheme)}>
                    <Table className={classes.tableLayout}>

                      <TableRow style={{ backgroundColor: grey[400] }}>
                        <StyledTableCell >
                          Sample Number
                        </StyledTableCell>
                        <StyledTableCell >
                          Equipment Description
                        </StyledTableCell>
                        <StyledTableCell >
                          Service Type
                        </StyledTableCell>
                        <StyledTableCell >
                          Sampled Date
                        </StyledTableCell>
                        <StyledTableCell >
                          Arrived Date
                        </StyledTableCell>
                        <StyledTableCell >
                          Analysed Date
                        </StyledTableCell>
                        <StyledTableCell >
                          Report Date
                        </StyledTableCell>
                        <StyledTableCell >
                          Status
                        </StyledTableCell>

                      </TableRow>

                      <TableBody>
                        {expandeditem[0].SampleList?.map((item, index) => (
                          <TableRow>
                            <TableCell >{item.SampleID}</TableCell>
                            <TableCell >{item.EquipmentDescription}</TableCell>
                            <TableCell >{item.ServiceType}</TableCell>
                            <TableCell >{item.SampledDate ? item.SampledDate : ""}</TableCell>
                            <TableCell >{item.ArrivedDate ? item.ArrivedDate : ""}</TableCell>
                            <TableCell >{item.AnalysedDate ? item.AnalysedDate : ""}</TableCell>
                            <TableCell >{item.ReportedDate ? item.ReportedDate : ""}</TableCell>
                            <TableCell >{item.Status}</TableCell>
                          </TableRow>

                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TableCell>
              </TableRow >

            ) : (
              ""
            )
          }
          {reporSubType == "Fuel" ? (
            <TableRow>
              <TableCell colSpan={colSpan1}>
                <TableContainer component={Paper} className={clsx(classes.TableTheme)}>
                  <Table className={classes.tableLayout}>

                    <TableRow style={{ backgroundColor: grey[400] }}>
                      <StyledTableCell >
                        Sample Number
                      </StyledTableCell>
                      {/* <StyledTableCell >
                        Vessel Name
                      </StyledTableCell> */}
                      <StyledTableCell >
                        Bunker Port
                      </StyledTableCell>
                      <StyledTableCell >
                        Fuel Grade
                      </StyledTableCell>
                      <StyledTableCell >
                        Report Type
                      </StyledTableCell>
                      <StyledTableCell >
                        Sampled Date
                      </StyledTableCell>
                      <StyledTableCell >
                        Arrived Date
                      </StyledTableCell>
                      <StyledTableCell >
                        Analysed Date
                      </StyledTableCell>
                      <StyledTableCell >
                        Reported Date
                      </StyledTableCell>
                      <StyledTableCell >
                        Status
                      </StyledTableCell>

                    </TableRow>

                    <TableBody>
                      {expandeditem1[0].SampleList?.map((item, index) => (
                        <TableRow>
                          <TableCell>{item.SampleNumber}</TableCell>
                          {/* <TableCell>{item.Vessel_Name}</TableCell> */}
                          <TableCell>{item.BunkerPort}</TableCell>
                          <TableCell>{item.FuelGrade}</TableCell>
                          <TableCell>{item.ReportType}</TableCell>
                          <TableCell>{item.SampledDate ? item.SampledDate : ""}</TableCell>
                          <TableCell>{item.ArrivedDate ? item.ArrivedDate : ""}</TableCell>
                          <TableCell>{item.AnalysedDate ? item.AnalysedDate : ""}</TableCell>
                          <TableCell>{item.ReportedDate ? item.ReportedDate : ""}</TableCell>
                          <TableCell>{item.Status}</TableCell>
                        </TableRow>

                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TableCell>
            </TableRow >

          ) : (
            ""
          )
          }

          {
            reporSubType == "Tot" ? (
              <TableRow>
                <TableCell colSpan={colSpan2}>
                  <TableContainer component={Paper} className={clsx(classes.TableTheme)}>
                    <Table className={classes.tableLayout}>

                      <TableRow style={{ backgroundColor: grey[400] }} className={classes.tablehead}>
                        <StyledTableCell >
                          Sample Number
                        </StyledTableCell>
                        <StyledTableCell >
                          Asset Name
                        </StyledTableCell>
                        <StyledTableCell >
                          Service Type
                        </StyledTableCell>
                        <StyledTableCell >
                          Sampled Date
                        </StyledTableCell>
                        <StyledTableCell >
                          Arrived Date
                        </StyledTableCell>
                        <StyledTableCell >
                          Analysed Date
                        </StyledTableCell>
                        <StyledTableCell >
                          Reported Date
                        </StyledTableCell>
                        <StyledTableCell >
                          Status
                        </StyledTableCell>
                      </TableRow>

                      <TableBody>
                        {expandeditem2[0].SampleList?.map((item, index) => (
                          <TableRow>
                            <TableCell>{item.SampleNumber}</TableCell>
                            <TableCell>{item.AssetName}</TableCell>
                            <TableCell>{item.ServiceType}</TableCell>
                            <TableCell>{item.SampledDate  ? item.SampledDate : ""}</TableCell>
                            <TableCell>{item.ArrivedDate  ? item.ArrivedDate: ""}</TableCell>
                            <TableCell>{item.AnalysedDate ? item.AnalysedDate: ""}</TableCell>
                            <TableCell>{item.ReportedDate ? item.ReportedDate : ""}</TableCell>
                            <TableCell>{item.Status}</TableCell>
                          </TableRow>

                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TableCell>
              </TableRow >
            ) : (
              ""
            )
          }
        </>
      );


    },
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
      console.log(curExpanded, allExpanded, rowsExpanded),
  };

  const getFlagColor = (status) => {
    var flagcls;
    switch (status) {
      case "Satisfactory":
        flagcls = {
          color: "#008000"
        };
        break;
      case "Critical":
        flagcls = {
          color: "red"
        };
        break;
      case "Warning":
        flagcls = {
          color: "#CA6F1E "
        };
        break;
      case "Other":
        flagcls = {
          color: "#73C6B6"
        };
        break;
      default:

    }
    return flagcls;

  };
  return (
    <div>
      <Box component="main" px={3} pb={0} display="flex">
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Box display="dlock">
              <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpen} />} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <div>
        <Box component="div" className="pos_relative">


          {/*<Button onChange={handleClickOpen}/>*/}

          <Dialog
            open={openformFuel}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="scroll-dialog-title" color="white">Samples</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
              <DialogContentText
                id="scroll-dialog-description"
                //ref={descriptionElementRef}
                tabIndex={-1}
              >
                <p className="subtitle">Fuel Analysis</p><br />
                <p className="subtitle">Help On Filter Panel</p><br />
                <img className="maxwidth100" src="/assets/images/Sample-Fuel-Filter.jpg"></img><br /><br />
                <p>
                  <li>Click and type on the fields to see the options</li><br />
                  <li>For multiple selections hold <img src={ctrl} width="40px" height="40px" /> to select options from the list</li><br />
                  <li>Click <ClearIcon color="disabled" /> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px" /></li><br />
                  <li>Click <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /> </li><br />
                  <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected filters</li><br />
                  <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                  <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                  <li>Default sample date for fuel is 90days , and these default sample date can be changed manually</li>
                </p><br /><br />
                <p className="subtitle">Help On Sample Fuel Section</p><br />
                <img className="maxwidth100" src="/assets/images/Sample-Fuel-Status.jpg"></img><br /><br />
                <p>
                  <li>Shows the No. of samples under the classification of </li>
                  1.	Arrived at the Lab,<br />
                  2.	Analysed,<br />
                  3.	Reported,<br />
                  4.	Other<br />
                  Any sample without status of 1 to 3 will be grouped as “other”<br /><br />
                  <li>Shows the No. of samples of each of the service types of Fuel Analysis</li><br />
                  <li>Click on the progress bar to display status based on the service type <img src={sample_fuel_progressbar} alt="" width="200px" height="200px" /></li><br />
                </p><br />
                <img className="maxwidth100" alt="" src="/assets/images/Sample-Fuel-Table.jpg"></img><br /><br />
                <p>
                  <li>Click <ArrowForwardIosIcon sx={{ transform: "rotateZ(90deg)" }} color="disabled" /> to see the particular ship details</li><br />
                  <li>Click <ArrowForwardIosIcon sx={{ transform: "rotateZ(270deg)" }} color="disabled" /> to close the particular ship details</li>
                </p>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClickClose}>Close</Button>
            </DialogActions>
          </Dialog>


          <Dialog
            open={openformLube}
            //onClose={handleClickCloseLube}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="scroll-dialog-title" color="white">Samples</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
              <DialogContentText
                id="scroll-dialog-description"
                //ref={descriptionElementRef}
                tabIndex={-1} >
                <p className="subtitle">Lube Analysis</p><br />
                <p className="subtitle">Help On Filter Panel</p><br />
                <img className="maxwidth100" src="/assets/images/Sample-Lube-Filter.jpg"></img><br /><br />
                <p>
                  <li>Click and type on the fields to see the options</li><br />
                  <li>For multiple selections hold <img src={ctrl} alt="" width="40px" height="40px" /> to select options from the list</li><br />
                  <li>Click <ClearIcon color="disabled" /> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px" /></li><br />
                  <li>Click <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /></li><br />
                  <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected options</li><br />
                  <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                  <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                  <li>Default sample date for lube is 180days , and these default sample date can be changed manually</li>
                </p><br /><br />
                <p className="subtitle">Help On Sample Lube Section</p><br />
                <img className="maxwidth100" src="/assets/images/Sample-Lube-Status.jpg"></img><br /><br />
                <p>
                  <li>Shows the No. of samples under the classification of </li>
                  1.	Arrived at the Lab,<br />
                  2.	Analysed,<br />
                  3.	Reported,<br />
                  4.	Other<br />
                  Any sample without status of 1 to 3 will be grouped as “other”<br /><br />
                  <li>Shows the No. of samples of each of the service types of Lube Analysis</li><br />
                  <li>Click on the progress bar to display status based on the service type <img src={sample_lube_progressbar} alt="" width="200px" height="200px" /></li><br />
                </p><br />
                <img className="maxwidth100" alt="" src="/assets/images/Sample-Lube-Table.jpg"></img><br /><br />
                <p>
                  <li>Click <ArrowForwardIosIcon sx={{ transform: "rotateZ(90deg)" }} color="disabled" /> to see the particular ship details</li><br />
                  <li>Click <ArrowForwardIosIcon sx={{ transform: "rotateZ(270deg)" }} color="disabled" /> to close the particular ship details</li>
                </p>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClickCloseLube}>Close</Button>
            </DialogActions>
          </Dialog>


          <Dialog
            open={openformTot}
            //onClose={handleClickCloseLube}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="scroll-dialog-title" color="white">Samples</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
              <DialogContentText
                id="scroll-dialog-description"
                //ref={descriptionElementRef}
                tabIndex={-1} >
                <p className="subtitle">VPS Power</p><br />
                <p className="subtitle">Help On Filter Panel</p><br />
                <img className="maxwidth100" src="/assets/images/Sample-Tot-Filter.jpg"></img><br /><br />
                <p>
                  <li>Click and type on the fields to see the options</li><br />
                  <li>For multiple selections hold <img src={ctrl} alt="" width="40px" height="40px" /> to select options from the list</li><br />
                  <li>Click <ClearIcon color="disabled" /> to clear all the selection in a particular field <img src={clear} alt="" width="300px" height="300px" /></li><br />
                  <li>Click <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /></li><br />
                  <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected options</li><br />
                  <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                  <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                  <li>Default sample date for VPS Power is 720days , and these default sample date can be changed manually</li>
                </p><br /><br />
                <p className="subtitle">Help On Sample VPS Power Section</p><br />
                <img className="maxwidth100" src="/assets/images/Sample-Tot-Status.jpg"></img><br /><br />
                <p>
                  <li>Shows the No. of samples under the classification of </li>
                  1.	Arrived at the Lab,<br />
                  2.	Analysed,<br />
                  3.	Reported,<br />
                  4.	Other<br />
                  Any sample without status of 1 to 3 will be grouped as “other”<br /><br />
                  <li>Shows the No. of samples of each of the service types of VPS Power</li><br />
                  <li>Click on the progress bar to display status based on the service type <img src={sampleprogressbar} alt="" width="200px" height="200px" /></li><br />
                </p><br />
                <img className="maxwidth100" alt="" src="/assets/images/Sample-Tot-Table.jpg"></img><br /><br />
                <p>
                  <li>Click <ArrowForwardIosIcon sx={{ transform: "rotateZ(90deg)" }} color="disabled" /> to see the particular Transformer details</li><br />
                  <li>Click <ArrowForwardIosIcon sx={{ transform: "rotateZ(270deg)" }} color="disabled" /> to close the particular Transformer details</li>
                </p>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClickCloseTot}>Close</Button>
            </DialogActions>
          </Dialog>
        </Box>
      </div>
      <Box className="reports-filter" >
        <Box
          display="block"
          mx={4}
          my={3}
          bgcolor="#fff"
          boxShadow={1}
          borderRadius={4}
          component="div"
        >
          {
            reportType == "SampleStatus" ? (
              <React.Fragment>
                {reporSubType == "Tot" ? (<FiltersSampleTot filterSampleTot={filterSampleTot} clearFilter={clearFilter} defaultDate={getDefaultTotDate()} FormatClearFilter={FormatClearFilter} />) : reporSubType == "Lube" ? (<FiltersSampleLube filterSampleLube={filterSampleLube} clearFilter={clearFilter} IntialLubeLoadEffect={IntialLubeLoadEffect} OnResetValue={DateFieldChange} defaultDate={getDefaultLubeDate()} FormatClearFilter={FormatClearFilter} />) : (<FiltersSampleFule filterSampleFuel={filterSampleFuel} clearFilter={clearFilter} defaultDate={getDefaultFuelDate()} FormatClearFilter={FormatClearFilter} />)}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {reporSubType == "Tot" ? (
                  <FiltersReportTot filterReportTot={filterReportTot} clearFilter={clearFilter} />) : reporSubType == "Lube" ? (
                    <FiltersReportLube filterReportLube={filterReportLube} clearFilter={clearFilter} />) : (<FiltersReportFuel filterReportFual={filterReportFual} clearFilter={clearFilter} />)}
              </React.Fragment>
            )
          }
        </Box>
        <Box
          display="block"
          mx={4}
          my={3}
          py={2}
          px={3}
          bgcolor="#fff"
          boxShadow={1}
          borderRadius={4}
          component="div"
        >
          <Box display="flex" component="div">
            <Grid container>
              <Grid item xs={12} sm={12} md={5}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={11}>
                    {
                      reportType == "SampleStatus" ? (
                        <ReportFormat
                          type="SampleStatus"
                          key="SampleFormatPart"
                          row={sampleFormatActive || {}}
                          filterSampleFuel={filterSampleFuel}
                          filterSampleLube={filterSampleLube}
                          filterSampleTot={filterSampleTot}
                          clearFilter={clearFilter}
                          reportsubType={reporSubType}
                          clearBarSelection={clearBarSelection}
                          tabName={tabName}
                          //formObj={globalFilterObj}
                          barData={globalFilterObj}
                          isEmpty={isEmpty}
                          tab={tab}
                          ClearProgressBar={ClearProgressBar}
                          DataProgressBar={DataProgressBar}
                          Resetclearprogressbar={Resetclearprogressbar}


                        />
                      ) : (
                        <ReportFormat
                          type="ReportStatus"
                          key="ReportFormatPart"
                          row={reportFormatActive || {}}

                        />
                      )

                    }

                  </Grid>
                </Grid>

              </Grid>
              <Grid item xs={12} sm={12} md={7}>
                <Box component="div" display="block">
                  {reportType == "SampleStatus" ? (
                    <SampleStatus key="ReportDataPart"
                      reporSubType={reporSubType} tabActive={tabSampleActive} dashtab={props.location.dashtab}
                      reportObj={reportDetailsList}
                      sampleStatusDetails={reportDetailsList}
                      getChangedTab={getChangedTab} />) : (
                    <ReportStatus key="ReportDataPart"
                      reporSubType={reporSubType} tabActive={tabReportActive}
                      reportObj={reportDetailsList}
                      reportStatusDetails={reportDetailsList} />
                  )}

                </Box>
              </Grid>
            </Grid>
          </Box>

          <>
            {/* <TableContainer component={Paper} className={classes.boxShadow_0}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow> */}
            {/* <StyledTableCell className="bl-bg" />
                        <StyledTableCell className="bl-bg">Customer Contract</StyledTableCell>
                        <StyledTableCell className="bl-bg">
                          {reporSubType == "Tot" ? " Asset Name " : " Ship Name (IMO) "}
                        </StyledTableCell>
                        <StyledTableCell className="bl-bg"> */}
            {/* {reporSubType=="Tot"?"":reporSubType=="Fuel"?"":"Dispatch Port"} */}
            {/* </StyledTableCell>
                        <StyledTableCell className="bl-bg"> */}
            {/* {reporSubType=="Tot"?"Sampled Date":reporSubType=="Fuel"?"":"Sampled Date"} */}
            {/* </StyledTableCell>
                        <StyledTableCell className="bl-bg"> */}
            {/* {reporSubType=="Tot"?"Status":reporSubType=="Fuel"?"":"Status"} */}
            {/* </StyledTableCell> */}
            {/* <StyledTableCell className="bl-bg" padding="checkbox">
                    <MyCheckbox
                      checked={selectedRowCount}
                      onChange={(event) => {
                        selectAllCheckbox(event);
                      }}
                    />
                  </StyledTableCell> */}
            {/* </TableRow>
                    </TableHead>
                    <TableBody> */}
            {/* {
                        reporSubType == "Tot" ? (
                          <React.Fragment>
                            {reportData.length
                              ? reportData.map((item, index) => (
                                <RowSampleTot
                                  key={item.CustomerContract + "_" + index}
                                  index={index}
                                  getDownload={getDownload}
                                  // data={reportTableData}
                                  // updateData={updateReportTableData}
                                  row={item}
                                />
                              ))
                              : (
                                <TableRow >
                                  <TableCell colSpan="6">
                                    <Box>No Record Found</Box>
                                  </TableCell>
                                </TableRow>
                              )} */}
            {/* </React.Fragment>
                        ) : reporSubType == "Lube" ? (
                          <React.Fragment>
                            {reportData.length
                              ? reportData.map((item, index) => (
                                <RowSampleLube
                                  key={item.CustomerContract + "_" + index}
                                  index={index}
                                  getDownload={getDownload}
                                  // data={reportTableData}
                                  // updateData={updateReportTableData}
                                  row={item}
                                />
                              ))
                              : (
                                <TableRow >
                                  <TableCell colSpan="6">
                                    <Box>No Record Found</Box>
                                  </TableCell>
                                </TableRow>
                              )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {reportData.length
                              ? reportData.map((item, index) => (
                                <RowSampleFual
                                  key={item.CustomerContract + "_" + index}
                                  index={index}
                                  getDownload={getDownload}
                                  // data={reportTableData}
                                  // updateData={updateReportTableData}
                                  row={item}
                                />
                              ))
                              : (
                                <TableRow >
                                  <TableCell colSpan="6">
                                    <Box>No Record Found</Box>
                                  </TableCell>
                                </TableRow>
                              )}
                          </React.Fragment>
                        )
                      } */}
            {/* </TableBody>
                  </Table>
                </TableContainer> */}
            {/* //</Box> */}
          </>
          {
            reportType == "SampleStatus" ? (

              <Box display="block" mb={3} my={3} component="div" className="reportstablehead">
                {/* <TableContainer component={Paper} className={classes.boxShadow_0}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow> */}
                {/* <StyledTableCell className="bl-bg" />
                        <StyledTableCell className="bl-bg">Customer Contract</StyledTableCell>
                        <StyledTableCell className="bl-bg">
                          {reporSubType == "Tot" ? " Asset Name " : " Ship Name (IMO) "}
                        </StyledTableCell>
                        <StyledTableCell className="bl-bg"> */}
                {/*  {reporSubType=="Tot"?"":reporSubType=="Fuel"?"":"Dispatch Port"} */}
                {/* </StyledTableCell>
                        <StyledTableCell className="bl-bg"> */}
                {/* {reporSubType=="Tot"?" Report Date ":reporSubType=="Fuel"?"":" Bunkered Date"} */}
                {/* </StyledTableCell>
                        <StyledTableCell className="bl-bg"> */}
                {/* {reporSubType=="Tot"?"Status":reporSubType=="Fuel"?"" :"Status"} */}
                {/* </StyledTableCell> */}
                {/* <StyledTableCell className="bl-bg" padding="checkbox">
                    <MyCheckbox
                      checked={selectedRowCount}
                      onChange={(event) => {
                        selectAllCheckbox(event);
                      }}
                    />
                  </StyledTableCell> */}
                {/* </TableRow>
                    </TableHead>
                    <TableBody> */}
                {/* {
                        reporSubType == "Tot" ? (
                          <React.Fragment>
                            {reportData.length
                              ? reportData.map((item, index) => (
                                <RowReportTot
                                  key={item.CustomerContract + "_" + index}
                                  index={index}
                                  getDownload={getDownload}
                                  // data={reportTableData}
                                  // updateData={updateReportTableData}
                                  row={item}
                                />
                              ))
                              : (
                                <TableRow >
                                  <TableCell colSpan="6">
                                    <Box>No Record Found</Box>
                                  </TableCell>
                                </TableRow>
                              )}
                          </React.Fragment>
                        ) : reporSubType == "Lube" ? (
                          <React.Fragment>
                            {reportData.length
                              ? reportData.map((item, index) => (
                                <RowReportLube
                                  key={item.CustomerContract + "_" + index}
                                  index={index}
                                  getDownload={getDownload}
                                  // data={reportTableData}
                                  // updateData={updateReportTableData}
                                  row={item}
                                />
                              ))
                              : (
                                <TableRow >
                                  <TableCell colSpan="6">
                                    <Box>No Record Found</Box>
                                  </TableCell>
                                </TableRow>
                              )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {reportData.length
                              ? reportData.map((item, index) => (
                                <RowReportFual
                                  key={item.CustomerContract + "_" + index}
                                  index={index}
                                  getDownload={getDownload}
                                  // data={reportTableData}
                                  // updateData={updateReportTableData}
                                  row={item}
                                />
                              ))
                              : (
                                <TableRow >
                                  <TableCell colSpan="6">
                                    <Box>No Record Found</Box>
                                  </TableCell>
                                </TableRow>
                              )}
                          </React.Fragment>
                        )
                      } */}
                {/* </TableBody>
                  </Table>
                </TableContainer> */}
                <ThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    className={classes.tableBody}
                    data={reportData}
                    columns={grouping == "false" ? getGridHeader2(reporSubType) : getGridHeader(reporSubType)}
                    options={options}
                    components={{ TableFilterList: CustomFilterList, }}
                  />
                  {/* <Confirmation open={openAlert}  onHandleSubmit={toggleRow} />  */}
                  {/*<Confirmation open={openAlert} onClose={handleClose} onHandleSubmit={onAlertSubmit} BMhistorydata={Bunkermasterhistory} /> */}
                </ThemeProvider>


              </Box>
            ) : (
              ""
            )

          }
        </Box>
      </Box>
    </div>
  );

}